<template>
  <div class="container" style="position:relative">
    <div class="placeholderArea" :id="'nav' + 0"></div>
    <Search></Search>
    <HomeNav></HomeNav>
    <RightFlex></RightFlex>
    <BackTop></BackTop>
    <!-- 商品显示区域 -->

    <div class="content public-container" style="position: relative;">
      <div class="placeholderArea" :id="'nav' + 1"></div>
      <!-- 超值拼团 -->
      <div class="scrabbleDough stairs" v-if="scrabbleList && scrabbleList.length > 0">
        <!--头部-->
        <div class="weekly-title">
          <div class="hot-content">
            <div class="weekly-title-logo">超值拼团</div>
            <div class="weekly-time">
              <div class="weekly-more">
                <router-link to="/ScrabbleDoughZone">
                  查看更多
                  <Icon type="ios-arrow-forward" />
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!--头部-->
        <div class="scrabbleDough-content">
          <div class="scrabbleDough-box" v-for="(item, index) in scrabbleList" :key="index">
            <div class="scrabbleDough-img">
              <div>
                <img class="move-img" :src="item.goods_img || '../../../static/img/goodsList/goods_default_img.jpg'"
                  :onerror="defaultGoodsImg" alt="图片破损" />
              </div>
            </div>
            <div class="scrabbleDough-time">
              <div class="scrabbleDough-people">
                <p>已有 <span class="num-size">{{ item.count_people }}</span> 人拼团</p>
                <p class="line24">距拼团{{ item.type == 1 ? "开始" : "结束" }}</p>
              </div>
              <div class="scrabbleDough-timeBox">
                <p>已拼 <span class="num-size">{{ item.count_quantity }}</span> {{ item.unit }}</p>
                <p class="scrabbleDough-countdown">
                  <!--  <span class="time-box">{{item.scrabbleCountDownDay}}</span>
                                  <span>:</span>
                                  <span class="time-box">{{item.scrabbleCountDownHour}}</span>
                                  <span>:</span>
                                  <span class="time-box">{{item.scrabbleCountDownMin}}</span>
                                  <span>:</span>
                                  <span class="time-box">{{item.scrabbleCountDownSec}}</span>-->
                  <Countdown :timestamp="item.timestamp" @end="endTime" />
                </p>
              </div>
              <div class="scrabbleDough-progress">
                <Progress :percent="item.jindu" hide-info :stroke-width="7" />
              </div>
            </div>
            <div class="scrabbleDough-m20">
              <div class="scrabbleDough-name">{{ item.goods_name }}</div>
              <div class="scrabbleDough-manu">{{ item.manufacturer_name }}</div>
              <div class="scrabbleDough-spec">规格：{{ item.specification }}</div>
              <div class="scrabbleDough-expiryDate">效期：{{ item.expiration_date }}</div>
              <div class="scrabbleDough-rule">起购{{ item.quantity_min }}—限购{{ item.quantity_max }}</div>
              <div class="scrabbleDough-num">
                <div class="scrabbleDough-stock">
                  剩余库存：<span class="color">{{ item.goods_number }}</span>
                </div>
                <div class="goods-num">
                  <span class="reduce-num" @click.stop="reduceCart(item, index)">-</span>
                  <input type="text" v-model="item.add_init" @blur="quantityChange(item, index)" />
                  <span class="add-num" @click.stop="addCart(item, index)">+</span>
                </div>
              </div>
              <div class="scrabbleDough-price">
                <p>
                  <span class="goods-price">￥{{ item.up_price }}</span>
                  <span class="goods-old-price" v-if="item.up_price !== item.price"><s>￥{{ item.price }}</s></span>
                </p>
                <p v-if="item.type === 1" class="goods-cart">预告中</p>
                <p v-if="item.type === 2" class="goods-cart-1" @click.stop="addToCart(item)">立即购买</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 超值拼团 -->

      <!-- 秒杀 -->
      <div class="seckill stairs" v-if="seckillGoodList && seckillGoodList.length > 0">
        <!-- 头部 -->
        <div class="seckill-head">
          <div class="seckill-icon">
            <img src="static/img/index/clock.png" />
          </div>
          <div class="seckill-text">{{ curSeckillData.sk_name || "" }}</div>
          <div class="count-down">
            <span class="count-down-hour">{{ countDownTime }}</span>
            <!-- <span class="count-down-hour">{{ seckillsHours }}</span>
            <span>:</span>
            <span class="count-down-minute">{{ seckillsMinutes }}</span>
            <span>:</span>
            <span class="count-down-seconds">{{ seckillsSeconds }}</span> -->
          </div>
          <div class="seckill-text-1">剩余抢购时间</div>
          <router-link to="/Seckill" class="seckill-more">进入秒杀</router-link>
          <div class="next-seckill" @click.stop="curSeckillIndex++">
            下一场秒杀
            <Icon type="ios-arrow-forward" />
          </div>
        </div>
        <!-- 内容 -->
        <div class="seckill-content">
          <!-- Swiper -->
          <div class="swiper-container" v-if="curSeckillData">
            <div class="swiper-wrapper">
              <div class="swiper-slide swiper-item" v-for="(item, index) in curSeckillData.goods" :key="index">
                <div class="seckill-item">
                  <router-link to="/Seckill">
                    <div class="seckill-item-img">
                      <img :src="item.picture ||
                        '../../static/img/goodsList/goods_default_img.jpg'
                        " :onerror="defaultGoodsImg" alt="图片破损" />
                    </div>
                    <div class="seckill-item-info">
                      <p class="seckill-item-intro">{{ item.goods_name }}</p>
                      <p class="seckill-item-spec">{{ item.specification }}</p>
                      <!--  <p class="seckill-item-noLogin" v-show="!userInfo.username">价格登录可见</p>-->
                      <p class="seckill-item-loginPrice" v-show="!!userInfo.username">
                        <span class="seckill-price text-danger">
                          <Icon type="social-yen"></Icon>{{ item.skg_price }}
                        </span>
                        <span class="seckill-old-price"><s>{{ item.skg_price }}</s></span>
                      </p>
                      <Progress :percent="item.jindu > 100 ? 100 : item.jindu < 0 ? 0 : item.jindu" :stroke-width="6" />
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
            <!-- Add Pagination -->
            <div class="swiper-scrollbar"></div>
          </div>
        </div>
      </div>
      <!-- 秒杀 -->

      <!--热销商品-诊所精选-->
      <div class="hotGoods-item stairs" style="position:relative">
        <div class="placeholderArea" :id="'nav' + 7"></div>
        <!--头部-->
        <div class="weekly-title">
          <div class="hot-content">
            <div class="weekly-title-logo">诊所精选</div>
            <div class="weekly-time">
              <div class="weekly-more">
                <router-link to="/SubsidyZone">
                  查看更多
                  <Icon type="ios-arrow-forward" />
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!--头部-->
        <!--内容-->
        <!--特价分类-->
        <!--   <div class="weekly-classify">
          <ul class="weekly-classify-ul">
            &lt;!&ndash;  <li v-for="(item, index) in weekly.link" :key="index">{{item}}</li>&ndash;&gt;
            <li class="active">呼吸系统用药</li>
            <li>呼吸系统用药</li>
          </ul>
        </div>-->
        <!--特价分类-->

        <div class="week-items">
          <div class="weekly-other-item">
            <div class="weekly-goods" v-for="(item, index) in hotGoodsList.goodsL" :key="index"
              @click="goIndexDetail(item)">
              <!-- <p class="weekly-goods-icon">高毛</p>-->
              <!--单个促销标签-->

              <div class="pro-one" v-if="item.lables.split(',').length == 1">
                <!-- <p class="promotion-gm promotion-xp" v-if="false">新品</p> -->
                <div class="tag-img-wrap">
                  <p v-if="item.lables === '' || item.lables === '0'"></p>
                  <p class="promotion-zs" v-else-if="item.lables === '2'">
                    <img src="static/img/goodsList/pro_zs.png" alt="" />
                  </p>
                  <p class="promotion-hg" v-else-if="item.lables === '3'">
                    <img src="static/img/goodsList/pro_hg.png" alt="" />
                  </p>
                  <p class="promotion-ms" v-else-if="item.lables === '8'">
                    <img src="static/img/goodsList/pro_ms.png" alt="" />
                  </p>
                  <p class="promotion-xq" v-else-if="item.lables === '4'">
                    <img src="static/img/goodsList/pro_xq.png" alt="" />
                  </p>
                  <p class="promotion-tj" v-else-if="item.lables === '1'">
                    <img src="static/img/goodsList/pro_tj.png" alt="" />
                  </p>
                  <!-- 其他的就显示文字 -->
                  <p class="promotion-gm" v-else>
                    {{ goodsLabelSet[item.lables] }}
                  </p>
                </div>
                <div class="tag-msg-wrap">
                  <!-- 买赠换购信息 -->
                  <p class="promotion-txt" v-if="item.lables === '2'">
                    {{ item.swap_msg }}
                  </p>
                  <!-- 	阶梯特价信息 -->
                  <p class="promotion-txt" v-if="item.lables === '5'">
                    {{ item.ladder_msg }}
                  </p>
                  <!-- 秒杀信息 -->
                  <p class="promotion-txt" v-if="item.lables === '8'">
                    {{ item.skill_msg }}
                  </p>
                </div>
              </div>
              <!--单个促销标签-->
              <!--多个促销标签-->
              <div class="pro-more" v-else>
                <!-- 截取前4个渲染 pro-other pro-other-2 3 4???-->
                <p v-for="(label, index) in getLabels(item.lables)" :class="{
                  'pro-more-1': index === 0,
                  'pro-more-2': index === 1,
                  'pro-more-3': index === 2,
                  'pro-more-4': index === 3,
                }" :key="index">
                  {{ goodsLabelSet[label] }}
                  <span class="pro-other pro-other-1">{{
                    item.ladder_msg
                  }}</span>
                </p>
                <!--收藏后变颜色-->
                <p class="weekly-goods-icon-2" v-if="item.favorites_type === 1" @click.stop="
                  handleCollect(item, 2, index, 'hotGoodsList.goodsL')
                  ">
                  <span>
                    <Icon type="md-heart-outline" size="18" />
                  </span>
                </p>
                <!--收藏后变颜色-->
                <p class="weekly-goods-img">
                  <img class="move-img" :src="item.img_url ||
                    '../../../static/img/goodsList/goods_default_img.jpg'
                    " :onerror="defaultGoodsImg" alt="图片破损" />
                </p>
                <p class="weekly-goods-intro">{{ item.goods_name }}</p>
                <p class="weekly-goods-spec">{{ item.specification }}</p>
                <!--  <p class="weekly-goods-noLogin" v-show="!userInfo.username">价格登录可见</p>-->
                <p class="weekly-goods-loginPrice">
                  <span class="weekly-price">￥{{ item.selling_price }}</span>
                  <span class="weekly-old-price" v-if="item.selling_price !== item.original_price"><s>￥{{
                    item.original_price }}</s></span>
                </p>
              </div>
              <p class="weekly-goods-icon-1 colorAll_bg" v-if="item.favorites_type === 0" @click.stop="
                handleCollect(item, 1, index, 'hotGoodsList.goodsL')
                ">
                <span>
                  <Icon type="md-heart-outline" size="18" />
                </span>
              </p>
              <!--收藏后变颜色-->
              <p class="weekly-goods-icon-2" v-if="item.favorites_type === 1" @click.stop="
                handleCollect(item, 2, index, 'hotGoodsList.goodsL')
                ">
                <span>
                  <Icon type="md-heart-outline" size="18" />
                </span>
              </p>
              <!--收藏后变颜色-->
              <p class="weekly-goods-img">
                <img class="move-img" :src="item.img_url ||
                  '../../../static/img/goodsList/goods_default_img.jpg'
                  " :onerror="defaultGoodsImg" alt="图片破损" />
              </p>
              <p class="weekly-goods-intro">{{ item.goods_name }}</p>
              <p class="weekly-goods-spec">{{ item.specification }}</p>
              <!--  <p class="weekly-goods-noLogin" v-show="!userInfo.username">价格登录可见</p>-->
              <p class="weekly-goods-loginPrice">
                <span class="weekly-price">￥{{ item.selling_price }}</span>
                <span class="weekly-old-price" v-if="item.selling_price !== item.original_price"><s>￥{{
                  item.original_price }}</s></span>
              </p>
            </div>
          </div>
          <div class="week-items-carousel">
            <Carousel v-model="hotValue" :arrow="hotSetting.arrow" :autoplay="hotSetting.autoplay"
              :autoplay-speed="hotSetting.autoplaySpeed">
              <CarouselItem v-for="(hotIts, hotIndex) in hotGoodsList.banner" :key="hotIndex">
                <div class="demo-carousel">
                  <router-link :to="{ path: hotIts.ad_url }"><img :src="hotIts.img_url ||
                    '../../../static/img/goodsList/goods_default_img.jpg'
                    " :onerror="defaultGoodsImg" alt="图片破损" /></router-link>
                </div>
              </CarouselItem>
              <!-- <CarouselItem>
                <div class="demo-carousel">
                  <router-link to="/"><img src="static/img/index/weekly/item_swiper_1.png" alt=""></router-link>
                </div>
              </CarouselItem>-->
            </Carousel>
          </div>
          <div class="weekly-other-item">
            <div class="weekly-goods" v-for="(item, index) in hotGoodsList.goodsR" :key="index"
              @click="goIndexDetail(item)">
              <!-- <p class="weekly-goods-icon">高毛</p>-->
              <!--单个促销标签-->

              <div class="pro-one" v-if="item.lables.split(',').length == 1">
                <!-- <p class="promotion-gm promotion-xp" v-if="false">新品</p> -->
                <div class="tag-img-wrap">
                  <p v-if="item.lables === '' || item.lables === '0'"></p>
                  <p class="promotion-zs" v-else-if="item.lables === '2'">
                    <img src="static/img/goodsList/pro_zs.png" alt="" />
                  </p>
                  <p class="promotion-hg" v-else-if="item.lables === '3'">
                    <img src="static/img/goodsList/pro_hg.png" alt="" />
                  </p>
                  <p class="promotion-ms" v-else-if="item.lables === '8'">
                    <img src="static/img/goodsList/pro_ms.png" alt="" />
                  </p>
                  <p class="promotion-xq" v-else-if="item.lables === '4'">
                    <img src="static/img/goodsList/pro_xq.png" alt="" />
                  </p>
                  <p class="promotion-tj" v-else-if="item.lables === '1'">
                    <img src="static/img/goodsList/pro_tj.png" alt="" />
                  </p>
                  <!-- 其他的就显示文字 -->
                  <p class="promotion-gm" v-else>
                    {{ goodsLabelSet[item.lables] }}
                  </p>
                </div>
                <div class="tag-msg-wrap">
                  <!-- 买赠换购信息 -->
                  <p class="promotion-txt" v-if="item.lables === '2'">
                    {{ item.swap_msg }}
                  </p>
                  <!-- 	阶梯特价信息 -->
                  <p class="promotion-txt" v-if="item.lables === '5'">
                    {{ item.ladder_msg }}
                  </p>
                  <!-- 秒杀信息 -->
                  <p class="promotion-txt" v-if="item.lables === '8'">
                    {{ item.skill_msg }}
                  </p>
                </div>
              </div>
              <!--单个促销标签-->
              <!--多个促销标签-->
              <div class="pro-more" v-else style="height: 26px; overflow: hidden">
                <!-- 截取前4个渲染 pro-other pro-other-2 3 4???-->
                <p v-for="(label, index) in getLabels(item.lables)" :class="{
                  'pro-more-1': index === 0,
                  'pro-more-2': index === 1,
                  'pro-more-3': index === 2,
                  'pro-more-4': index === 3,
                }" :key="index">
                  {{ goodsLabelSet[label] }}
                  <!-- <span class="pro-other pro-other-1">{{
                       item.ladder_msg
                     }}</span>-->
                </p>
              </div>
              <!--多个促销标签-->
              <p class="weekly-goods-icon-1 colorAll_bg" v-if="item.favorites_type === 0" @click.stop="
                handleCollect(item, 1, index, 'hotGoodsList.goodsR')
                ">
                <span>
                  <Icon type="md-heart-outline" size="18" />
                </span>
              </p>
              <!--收藏后变颜色-->
              <p class="weekly-goods-icon-2" v-if="item.favorites_type === 1" @click.stop="
                handleCollect(item, 2, index, 'hotGoodsList.goodsR')
                ">
                <span>
                  <Icon type="md-heart-outline" size="18" />
                </span>
              </p>
              <!--收藏后变颜色-->
              <p class="weekly-goods-img">
                <img class="move-img" :src="item.img_url ||
                  '../../../static/img/goodsList/goods_default_img.jpg'
                  " :onerror="defaultGoodsImg" alt="图片破损" />
              </p>
              <p class="weekly-goods-intro">{{ item.goods_name }}</p>
              <p class="weekly-goods-spec">{{ item.specification }}</p>
              <!--  <p class="weekly-goods-noLogin" v-show="!userInfo.username">价格登录可见</p>-->
              <p class="weekly-goods-loginPrice">
                <span class="weekly-price">￥{{ item.selling_price }}</span>
                <span class="weekly-old-price" v-if="item.selling_price !== item.original_price"><s>￥{{
                  item.original_price }}</s></span>
              </p>
            </div>
          </div>

          <!--内容-->
        </div>
        <div class="week-items-bottom">
          <div class="weekly-other-item">
            <div class="weekly-goods" v-for="(item, index) in hotGoodsList.goodsBottom" :key="index"
              @click="goIndexDetail(item)">
              <!-- <p class="weekly-goods-icon">高毛</p>-->
              <!--单个促销标签-->

              <div class="pro-one" v-if="item.lables.split(',').length == 1">
                <!-- <p class="promotion-gm promotion-xp" v-if="false">新品</p> -->
                <div class="tag-img-wrap">
                  <p v-if="item.lables === '' || item.lables === '0'"></p>
                  <p class="promotion-zs" v-else-if="item.lables === '2'">
                    <img src="static/img/goodsList/pro_zs.png" alt="" />
                  </p>
                  <p class="promotion-hg" v-else-if="item.lables === '3'">
                    <img src="static/img/goodsList/pro_hg.png" alt="" />
                  </p>
                  <p class="promotion-ms" v-else-if="item.lables === '8'">
                    <img src="static/img/goodsList/pro_ms.png" alt="" />
                  </p>
                  <p class="promotion-xq" v-else-if="item.lables === '4'">
                    <img src="static/img/goodsList/pro_xq.png" alt="" />
                  </p>
                  <p class="promotion-tj" v-else-if="item.lables === '1'">
                    <img src="static/img/goodsList/pro_tj.png" alt="" />
                  </p>
                  <!-- 其他的就显示文字 -->
                  <p class="promotion-gm" v-else>
                    {{ goodsLabelSet[item.lables] }}
                  </p>
                </div>
                <div class="tag-msg-wrap">
                  <!-- 买赠换购信息 -->
                  <p class="promotion-txt" v-if="item.lables === '2'">
                    {{ item.swap_msg }}
                  </p>
                  <!-- 	阶梯特价信息 -->
                  <p class="promotion-txt" v-if="item.lables === '5'">
                    {{ item.ladder_msg }}
                  </p>
                  <!-- 秒杀信息 -->
                  <p class="promotion-txt" v-if="item.lables === '8'">
                    {{ item.skill_msg }}
                  </p>
                </div>
              </div>
              <!--单个促销标签-->
              <!--多个促销标签-->
              <div class="pro-more" v-else style="height: 26px; overflow: hidden">
                <!-- 截取前4个渲染 pro-other pro-other-2 3 4???-->
                <p v-for="(label, index) in getLabels(item.lables)" :class="{
                  'pro-more-1': index === 0,
                  'pro-more-2': index === 1,
                  'pro-more-3': index === 2,
                  'pro-more-4': index === 3,
                }" :key="index">
                  {{ goodsLabelSet[label] }}
                  <!-- <span class="pro-other pro-other-1">{{
                   item.ladder_msg
                 }}</span>-->
                </p>
              </div>
              <!--多个促销标签-->
              <p class="weekly-goods-icon-1 colorAll_bg" v-if="item.favorites_type === 0" @click.stop="
                handleCollect(item, 1, index, 'hotGoodsList.goodsBottom')
                ">
                <span>
                  <Icon type="md-heart-outline" size="18" />
                </span>
              </p>
              <!--收藏后变颜色-->
              <p class="weekly-goods-icon-2" v-if="item.favorites_type === 1" @click.stop="
                handleCollect(item, 2, index, 'hotGoodsList.goodsBottom')
                ">
                <span>
                  <Icon type="md-heart-outline" size="18" />
                </span>
              </p>
              <!--收藏后变颜色-->
              <p class="weekly-goods-img">
                <img class="move-img" :src="item.img_url ||
                  '../../../static/img/goodsList/goods_default_img.jpg'
                  " :onerror="defaultGoodsImg" alt="图片破损" />
              </p>
              <p class="weekly-goods-intro">{{ item.goods_name }}</p>
              <p class="weekly-goods-spec">{{ item.specification }}</p>
              <!--  <p class="weekly-goods-noLogin" v-show="!userInfo.username">价格登录可见</p>-->
              <p class="weekly-goods-loginPrice">
                <span class="weekly-price">￥{{ item.selling_price }}</span>
                <span class="weekly-old-price" v-if="item.selling_price !== item.original_price"><s>￥{{
                  item.original_price }}</s></span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <!--热销商品-诊所精选-->

      <!-- 聚划算 -->
      <div class="weeklySpecial stairs" style="position: relative;">
        <div class="placeholderArea" :id="'nav' + 2"></div>
        <!--头部-->
        <div class="weekly-title">
          <div class="hot-content">
            <div class="weekly-title-logo">聚划算</div>
            <div class="weekly-time">
              <div class="weekly-more">
                <router-link to="/Promotion">
                  查看更多
                  <Icon type="ios-arrow-forward" />
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!--<div class="weekly-title">
          <div class="weekly-title-logo">
            <img src="static/img/index/weekly/title_img.png" alt="" />
          </div>
          <div class="weekly-time">
            <div class="count-down">
              &lt;!&ndash;     <Icon type="ios-time" size="30" />
              <span class="weekly-deadline">剩余时间：</span>
              &lt;!&ndash; <span class="count-down-num count-down-hour">{{
                weekLyCountDownTime
              }}</span> &ndash;&gt;
              <span
                v-if="parseInt(weekLyCountDownDay) > 0"
                class="count-down-num count-down-hour"
                >{{ weekLyCountDownDay }}天</span
              >
              <span
                class="count-down-point"
                v-if="parseInt(weekLyCountDownDay) > 0"
                >:</span
              >
              <span class="count-down-num count-down-hour">{{
                weekLyCountDownHour
              }}</span>
              <span class="count-down-point">:</span>
              <span class="count-down-num count-down-minute">{{
                weekLyCountDownMin
              }}</span>
              <span class="count-down-point">:</span>
              <span class="count-down-num count-down-seconds">{{
                weekLyCountDownSec
              }}</span>&ndash;&gt;
            </div>

            <div class="weekly-more">
              <router-link to="/Promotion">
                查看更多
                <Icon type="ios-arrow-forward" />
              </router-link>
            </div>
          </div>
        </div>-->

        <!--头部-->
        <!--内容-->
        <!--特价分类-->
        <div class="weekly-classify">
          <ul class="weekly-classify-ul">
            <!--  <li v-for="(item, index) in weekly.link" :key="index">{{item}}</li>-->
            <li @click="westernGoods" class="active">西药</li>
            <!-- <li @click="chineseGoods">中药</li>-->
          </ul>
        </div>
        <!--特价分类-->
        <div class="week-items">
          <div class="week-items-carousel">
            <Carousel v-model="weekValue" :autoplay="weekSetting.autoplay" :arrow="weekSetting.arrow"
              :autoplay-speed="weekSetting.autoplaySpeed">
              <CarouselItem v-for="(weekIts, weekIndex) in weeklyIndexList.banner" :key="weekIndex">
                <div class="demo-carousel">
                  <router-link :to="{ path: weekIts.ad_url }">
                    <img :src="weekIts.img_url ||
                      '../../../static/img/goodsList/goods_default_img.jpg'
                      " :onerror="defaultGoodsImg" alt="图片破损" />
                  </router-link>
                </div>
              </CarouselItem>
            </Carousel>
          </div>
          <div class="weekly-other-item">
            <div class="weekly-goods" v-for="(item, index) in weeklyIndexList.weeklyTop" :key="index"
              @click="goIndexDetail(item)">
              <!-- <p class="weekly-goods-icon">高毛</p>-->
              <!--单个促销标签-->

              <div class="pro-one" v-if="item.lables.split(',').length == 1">
                <!-- <p class="promotion-gm promotion-xp" v-if="false">新品</p> -->
                <div class="tag-img-wrap">
                  <p v-if="item.lables === '' || item.lables === '0'"></p>
                  <p class="promotion-zs" v-else-if="item.lables === '2'">
                    <img src="static/img/goodsList/pro_zs.png" alt="" />
                  </p>
                  <p class="promotion-hg" v-else-if="item.lables === '3'">
                    <img src="static/img/goodsList/pro_hg.png" alt="" />
                  </p>
                  <p class="promotion-ms" v-else-if="item.lables === '8'">
                    <img src="static/img/goodsList/pro_ms.png" alt="" />
                  </p>
                  <p class="promotion-xq" v-else-if="item.lables === '4'">
                    <img src="static/img/goodsList/pro_xq.png" alt="" />
                  </p>
                  <p class="promotion-tj" v-else-if="item.lables === '1'">
                    <img src="static/img/goodsList/pro_tj.png" alt="" />
                  </p>
                  <!-- 其他的就显示文字 -->
                  <p class="promotion-gm" v-else>
                    {{ goodsLabelSet[item.lables] }}
                  </p>
                </div>
                <div class="tag-msg-wrap">
                  <!-- 买赠换购信息 -->
                  <p class="promotion-txt" v-if="item.lables === '2'">
                    {{ item.swap_msg }}
                  </p>
                  <!-- 	阶梯特价信息 -->
                  <p class="promotion-txt" v-if="item.lables === '5'">
                    {{ item.ladder_msg }}
                  </p>
                  <!-- 秒杀信息 -->
                  <p class="promotion-txt" v-if="item.lables === '8'">
                    {{ item.skill_msg }}
                  </p>
                </div>
              </div>
              <!--单个促销标签-->
              <!--多个促销标签-->
              <div class="pro-more" v-else style="height: 26px; overflow: hidden">
                <!-- 截取前4个渲染 pro-other pro-other-2 3 4???-->
                <p v-for="(label, index) in getLabels(item.lables)" :class="{
                  'pro-more-1': index === 0,
                  'pro-more-2': index === 1,
                  'pro-more-3': index === 2,
                  'pro-more-4': index === 3,
                }" :key="index">
                  {{ goodsLabelSet[label] }}
                  <!-- <span class="pro-other pro-other-1">{{
                     item.ladder_msg
                   }}</span>-->
                </p>
              </div>
              <!--多个促销标签-->
              <!-- 收藏-特价 -->
              <p class="weekly-goods-icon-1 colorAll_bg" v-if="item.favorites_type === 0">
                <span>
                  <Icon type="md-heart-outline" size="18" @click.stop="
                    handleCollect(item, 1, index, 'weeklyIndexList.weeklyTop')
                    " />
                </span>
              </p>
              <!--收藏后变颜色-->
              <p class="weekly-goods-icon-2" v-if="item.favorites_type === 1">
                <span>
                  <Icon type="md-heart-outline" size="18" @click.stop="
                    handleCollect(item, 2, index, 'weeklyIndexList.weeklyTop')
                    " />
                </span>
              </p>
              <!--收藏后变颜色-->
              <p class="weekly-goods-img">
                <img class="move-img" :src="item.img_url ||
                  '../../../static/img/goodsList/goods_default_img.jpg'
                  " :onerror="defaultGoodsImg" alt="图片破损" />
              </p>
              <p class="weekly-goods-intro">{{ item.goods_name }}</p>
              <p class="weekly-goods-spec">{{ item.specification }}</p>
              <!--  <p class="weekly-goods-noLogin" v-show="!userInfo.username">价格登录可见</p>-->
              <p class="weekly-goods-loginPrice">
                <span class="weekly-price">￥{{ item.selling_price }}</span>
                <span class="weekly-old-price" v-if="item.selling_price !== item.original_price"><s>￥{{
                  item.original_price }}</s></span>
              </p>
            </div>
          </div>
        </div>
        <div class="week-items-bottom">
          <div class="weekly-other-item">
            <div class="weekly-goods" v-for="(item, index) in weeklyIndexList.weeklyBottom" :key="index"
              @click="goIndexDetail(item)">
              <!-- <p class="weekly-goods-icon">高毛</p>-->
              <!--单个促销标签-->

              <div class="pro-one" v-if="item.lables.split(',').length == 1">
                <!-- <p class="promotion-gm promotion-xp" v-if="false">新品</p> -->
                <div class="tag-img-wrap">
                  <p v-if="item.lables === '' || item.lables === '0'"></p>
                  <p class="promotion-zs" v-else-if="item.lables === '2'">
                    <img src="static/img/goodsList/pro_zs.png" alt="" />
                  </p>
                  <p class="promotion-hg" v-else-if="item.lables === '3'">
                    <img src="static/img/goodsList/pro_hg.png" alt="" />
                  </p>
                  <p class="promotion-ms" v-else-if="item.lables === '8'">
                    <img src="static/img/goodsList/pro_ms.png" alt="" />
                  </p>
                  <p class="promotion-xq" v-else-if="item.lables === '4'">
                    <img src="static/img/goodsList/pro_xq.png" alt="" />
                  </p>
                  <p class="promotion-tj" v-else-if="item.lables === '1'">
                    <img src="static/img/goodsList/pro_tj.png" alt="" />
                  </p>
                  <!-- 其他的就显示文字 -->
                  <p class="promotion-gm" v-else>
                    {{ goodsLabelSet[item.lables] }}
                  </p>
                </div>
                <div class="tag-msg-wrap">
                  <!-- 买赠换购信息 -->
                  <p class="promotion-txt" v-if="item.lables === '2'">
                    {{ item.swap_msg }}
                  </p>
                  <!-- 	阶梯特价信息 -->
                  <p class="promotion-txt" v-if="item.lables === '5'">
                    {{ item.ladder_msg }}
                  </p>
                  <!-- 秒杀信息 -->
                  <p class="promotion-txt" v-if="item.lables === '8'">
                    {{ item.skill_msg }}
                  </p>
                </div>
              </div>
              <!--单个促销标签-->
              <!--多个促销标签-->
              <div class="pro-more" v-else style="height: 26px; overflow: hidden">
                <!-- 截取前4个渲染 pro-other pro-other-2 3 4???-->
                <p v-for="(label, index) in getLabels(item.lables)" :class="{
                  'pro-more-1': index === 0,
                  'pro-more-2': index === 1,
                  'pro-more-3': index === 2,
                  'pro-more-4': index === 3,
                }" :key="index">
                  {{ goodsLabelSet[label] }}
                  <!-- <span class="pro-other pro-other-1">{{
                     item.ladder_msg
                   }}</span>-->
                </p>
              </div>
              <!--多个促销标签-->
              <p class="weekly-goods-icon-1 colorAll_bg" v-if="item.favorites_type === 0" @click.stop="
                handleCollect(item, 1, index, 'weeklyIndexList.weeklyBottom')
                ">
                <span>
                  <Icon type="md-heart-outline" size="18" />
                </span>
              </p>
              <!--收藏后变颜色-->
              <p class="weekly-goods-icon-2" v-if="item.favorites_type === 1" @click.stop="
                handleCollect(item, 2, index, 'weeklyIndexList.weeklyBottom')
                ">
                <span>
                  <Icon type="md-heart-outline" size="18" />
                </span>
              </p>
              <!--收藏后变颜色-->
              <p class="weekly-goods-img">
                <img class="move-img" :src="item.img_url ||
                  '../../../static/img/goodsList/goods_default_img.jpg'
                  " :onerror="defaultGoodsImg" alt="图片破损" />
              </p>
              <p class="weekly-goods-intro">{{ item.goods_name }}</p>
              <p class="weekly-goods-spec">{{ item.specification }}</p>
              <!--  <p class="weekly-goods-noLogin" v-show="!userInfo.username">价格登录可见</p>-->
              <p class="weekly-goods-loginPrice">
                <span class="weekly-price">￥{{ item.selling_price }}</span>
                <span class="weekly-old-price" v-if="item.selling_price !== item.original_price"><s>￥{{
                  item.original_price }}</s></span>
              </p>
            </div>
          </div>
        </div>


        <!--内容-->
      </div>
      <!-- 聚划算 -->

      <!-- 套餐专区 -->
      <div style="position:relative">
        <div class="placeholderArea" :id="'nav' + 8"></div>
        <SetMealArea />
      </div>
      <!-- 套餐专区 -->

      <!-- 超值钜惠 -->
      <div class="overflowList stairs" v-show="steepList.length > 0" style="position:relative">
        <div class="placeholderArea" :id="'nav' + 3"></div>
        <div class="weekly-title">
          <div class="hot-content">
            <div class="weekly-title-logo">超值钜惠</div>
            <div class="weekly-time">
            </div>
          </div>
        </div>
        <div class="overflow-content">
          <!-- Swiper -->
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide swiper-item" v-for="(item, i) in steepList" :key="i">
                <div class="seckill-item">
                  <router-link :to="item.ad_url">
                    <div class="seckill-item-img">
                      <img :src="item.img_url" alt="图片破损" />
                    </div>
                    <div class="seckill-item-info"></div>
                  </router-link>
                </div>
              </div>
            </div>
            <!-- Add Pagination -->
            <div class="swiper-scrollbar"></div>
          </div>
        </div>
        <!--三个广告位图-->
        <div class="weekly-item-prefecture">
          <div class="weekly-pre-img">
            <router-link to="/ClinicZone">
              <img src="static/img/index/weekly/item_pro_zs.png" alt="" />
            </router-link>
          </div>
          <div class="weekly-pre-img">
            <router-link to="/ApparatusZone">
              <img src="static/img/index/weekly/item_pro_zy.png" alt="" />
            </router-link>
          </div>
          <div class="weekly-pre-img">
            <router-link to="/DailyZone">
              <img src="static/img/index/weekly/item_pro_rhzq.jpg" alt="" />
            </router-link>
          </div>
        </div>
        <!--三个广告位图-->
      </div>
      <!-- 超值钜惠结束 -->




      <!-- 新品推荐+品牌专区 -->
      <div class="specialZone-item stairs" style="position:relative">
        <div class="placeholderArea" :id="'nav' + 4"></div>
        <div class="left-newPro">
          <div class="newGoods-title">
            <div class="newGoods-txt">
              新品推荐
              <span class="newGoods-txt-icon"><img src="static/img/index/specialZone/icon_right.png" alt="" /></span>
            </div>
            <p class="brandGoods-more">
              <router-link to="/GoodsList">
                查看更多
                <Icon type="ios-arrow-forward" />
              </router-link>
            </p>
            <!-- <p class="newGoods-classify">
              <span class="active">精选</span>
              <span>抗高血压</span>
              <span>头疼脑热</span>
              <span>清热消炎</span>
            </p>-->
          </div>
          <div class="newGoods-item">
            <div class="new-item-left">
              <router-link :to="{ path: newListBanner.ad_url }">
                <p class="new-left-img">
                  <!--    <img class="move-img" src="static/img/index/specialZone/spec_item_1.png" alt="">-->
                  <img class="move-img" :src="newListBanner.img_url ||
                    '../../../static/img/goodsList/goods_default_img.jpg'
                    " :onerror="defaultGoodsImg" alt="图片破损" />
                </p>
                <p class="new-left-intro">{{ newListBanner.goods_name }}</p>
                <p class="new-left-spec">{{ newListBanner.specification }}</p>
                <!--  <p class="new-left-noLogin" v-show="!userInfo.username">会员可见</p>-->
                <p class="new-left-loginPrice">
                  <span class="new-left-price">￥{{ newListBanner.selling_price }}</span>
                  <!--  <span class="new-left-oldPrice"><s>￥{{ newListBanner.original_price }}</s></span>-->
                </p>
              </router-link>
            </div>
            <div class="new-item-right">
              <div class="new-right-content">
                <div class="new-right-flex" v-for="(newItem, newIndex) in newList" :key="newIndex"
                  @click="goIndexDetail(newItem)">
                  <div class="new-right-box-1">
                    <p class="new-right-img">
                      <img class="move-img" :src="newItem.img_url ||
                        '../../../static/img/goodsList/goods_default_img.jpg'
                        " :onerror="defaultGoodsImg" alt="图片破损" />
                    </p>
                    <div class="new-right-describe">
                      <p class="new-right-intro">{{ newItem.goods_name }}</p>
                      <p class="new-right-spec">{{ newItem.specification }}</p>
                      <!--  <p class="new-right-noLogin" v-show="!userInfo.username">会员可见</p>-->
                      <p class="new-right-loginPrice">
                        <span class="new-right-price">￥{{ newItem.selling_price }}</span>
                        <!-- <span class="new-right-oldPrice"><s>￥{{ newItem.original_price }}</s></span>-->
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right-brand">
          <div class="brandGoods-title">
            <div class="brandGoods-txt">
              品牌专区
              <span class="brandGoods-txt-icon"><img src="static/img/index/specialZone/icon_right.png" alt="" /></span>
            </div>
            <p class="brandGoods-more">
              <router-link to="/BrandZone">
                查看更多
                <Icon type="ios-arrow-forward" />
              </router-link>
            </p>
          </div>
          <div class="bandGoods-container">
            <div class="bandGoods-left-img">
              <router-link :to="{ path: brandIndexBanner.ad_url }">
                <img class="move-img" :src="brandIndexBanner.img_url ||
                  '../../../static/img/goodsList/goods_default_img.jpg'
                  " :onerror="defaultGoodsImg" alt="图片破损" />
              </router-link>
            </div>
            <div class="bandGoods-right-goods">
              <ul class="bandGoods-right-ul">
                <li class="bandGoods-right-li" v-for="(brandItems, brandIndexs) in brandIndexList" :key="brandIndexs"
                  @click="goBrandList(brandItems)">
                  <span class="line"></span>
                  <img :src="brandItems.img_url ||
                    '../../../static/img/goodsList/goods_default_img.jpg'
                    " :onerror="defaultGoodsImg" alt="图片破损" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- 新品推荐+品牌专区 -->

      <!-- 好药推荐 -->
      <div class="stairs" style="position:relative">
        <div class="good-recommendation">
          <!-- 头部 -->
          <div class="good-head">
            <router-link :to="{ path: drugsListBanner.ad_url }">
              <img :src="drugsListBanner.img_url ||
                '../../../static/img/goodsList/goods_default_img.jpg'
                " :onerror="defaultGoodsImg" alt="图片破损" />
            </router-link>
          </div>
          <!-- 内容 -->
          <div class="good-rec-content">
            <!-- Swiper -->
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide swiper-item" v-for="(drugsItem, drugsIndex) in drugsList" :key="drugsIndex"
                  @click="goIndexDetail(drugsItem)">
                  <div class="seckill-item">
                    <router-link to="/GoodsList">
                      <div class="seckill-item-img">
                        <img :src="drugsItem.img_url ||
                          '../../../static/img/goodsList/goods_default_img.jpg'
                          " :onerror="defaultGoodsImg" alt="图片破损" />
                      </div>
                      <div class="seckill-item-info">
                        <p class="seckill-item-intro">
                          {{ drugsItem.goods_name }}
                        </p>
                        <p class="seckill-item-spec">
                          {{ drugsItem.specification }}
                        </p>
                        <!-- <p class="seckill-item-noLogin" v-show="!userInfo.username">会员可见</p>-->
                        <p class="seckill-item-loginPrice">
                          <span class="seckill-price text-danger">
                            <Icon type="social-yen"></Icon>{{ drugsItem.selling_price }}
                          </span>
                          <span class="seckill-old-price" v-if="drugsItem.selling_price !==
                            drugsItem.original_price
                            "><s>{{ drugsItem.original_price }}</s></span>
                        </p>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
              <!-- Add Pagination -->
              <div class="swiper-scrollbar"></div>
            </div>
          </div>
        </div>
        <!--<div class="good-item-prefecture">
          <div class="weekly-pre-img">
            <router-link to="/ApparatusZone">
              <img src="static/img/index/goodsRecom/goods_item_2.jpg" alt="" />
            </router-link>
          </div>
          <div class="weekly-pre-img">
            <router-link to="/DailyZone">
              <img src="static/img/index/goodsRecom/goods_item_3.jpg" alt="" />
            </router-link>
          </div>
        </div>-->
      </div>
      <!-- 好药推荐 -->



      <!-- 为你推荐 -->
      <div style="position:relative">
        <div :id="'nav' + 5"></div>
        <Recommend></Recommend>
      </div>

    </div>
    <!--左侧悬浮框-->
    <div id="floorBarId" class="floor">
      <div class="floor-nav">
        <div class="menu" v-for="item in tabs" :key="item.id" :class="[chooseIndex == item.id ? 'sele' : '']"
          @click="anchorPoint(item.id)">
          <!-- 首页 -->
          {{ item.title }}
        </div>
        <!-- <div class="menu" @click="jump(1)" :class="[num == 1 ? 'sele' : '']">
          <span v-if="scrabbleList && scrabbleList.length > 0">超值拼团</span>
        </div>
        <div class="menu" @click="jump(2)" :class="[num == 2 ? 'sele' : '']">
          <span>诊所精选</span>
        </div>
        <div class="menu" @click="jump(3)" :class="[num == 3 ? 'sele' : '']">
          <span>聚划算</span>
        </div>
        <div class="menu" @click="jump(4)" :class="[num == 4 ? 'sele' : '']">超值钜惠</div>
        <div class="menu" @click="jump(5)" :class="[num == 5 ? 'sele' : '']">精选商品</div>
        <div class="menu" @click="jump(6)" :class="[num == 6 ? 'sele' : '']">为你推荐</div> -->
        <!--    <ul id="floorNavList" class="floor-left-ul">
          <li class="nav-list-item">首页</li>
          <li class="nav-list-item active">百万补贴</li>
          <li class="nav-list-item">聚划算</li>
          <li class="nav-list-item">超值钜惠</li>
         &lt;!&ndash; <li class="nav-list-item">活动专区</li>&ndash;&gt;
          <li class="nav-list-item">精选商品</li>
         &lt;!&ndash; <li class="nav-list-item">医院精品</li>&ndash;&gt;
          <li class="nav-list-item">超值拼团</li>
          <li class="nav-list-item">为你推荐</li>
        </ul>-->
      </div>
    </div>
    <!--左侧悬浮框-->
    <!--悬浮领券-->
    <div class="coupons-img"><router-link to="/Receive"><img src="static/img/index/coupons_img1.png" alt=""></router-link>
    </div>
    <!--悬浮领券-->
    <!--首页弹出框-->
    <IndexPopup :indexVisible.sync="indexPopup" :popupData="popupData"></IndexPopup>
    <!--首页弹出框-->
    <Collect :CollectModel.sync="CollectPopup"></Collect>
    <NoCollect :NoCollectModel.sync="NoCollectPopup"></NoCollect>
  </div>
</template>

<script>
import Countdown from "@/components/personal/Countdown";
import SetMealArea from "@/components/components/SetMealArea.vue";
import Search from "@/components/Search";
import HomeNav from "@/components/nav/HomeNav";
import RightFlex from "@/components/nav/RightFlex";
import BackTop from "@/components/nav/BackTop";
import Recommend from "@/components/public/Recommend";
import IndexPopup from "@/components/popup/IndexPopup";
import store from "@/vuex/store";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import $ from "jquery";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import {
  getIndexSeckill,
  getIndexCenter,
  getBrandList,
  getWeeklyList,
  getIndexBulletFrame,
  getIndexBargains,
  getIndexScrabbleDough
} from "@/api/index";
import { defaultGoodsLabelSet } from "@/components/nav/staticData";
import { collection } from "@/api/goods";
import Collect from "@/components/popup/Collect";
import NoCollect from "@/components/popup/NoCollect";
import { isEmpty } from "@/utils";

export default {
  name: "Index",
  data() {
    return {
      num: 0,//楼层index
      steepList: [],
      scrabbleList: [],//拼团列表
      setIntervalObj: null,
      setIntervalWeekly: null,
      weekValue: 0, //天天特价value
      weekSetting: {
        arrow: "never",
        autoplay: true,
        autoplaySpeed: 3000,
      },
      hotValue: 0, //热销商品value
      hotSetting: {
        arrow: "never",
        autoplay: true,
        autoplaySpeed: 3000,
      },
      value2: 0,
      setting: {
        arrow: "never",
        autoplay: true,
        autoplaySpeed: 3000,
      },
      sideCart: false,
      defaultGoodsImg:
        'this.src="' +
        require("../../static/img/goodsList/goods_default_img.jpg") +
        '"',
      goodsList: [],
      seckillGoodList: [], //接口秒杀列表
      curSeckillData: {}, //当前秒杀数据
      curSeckillIndex: 0, //秒杀索引
      indexCenterList: {
        /*  bottomL:[],
        bottomR:[]*/
      }, //首页中间层
      hotGoodsList: {
        banner: [],
        goodsL: [],
        goodsR: [],
        goodsBottom: [],
      }, //
      goodsLabelSet: defaultGoodsLabelSet,
      newList: [], //新品推荐
      newListBanner: "", //新品左侧大图
      brandIndexList: [], //首页品牌列表
      brandIndexBanner: "", //首页品牌左侧大图
      weeklyIndexList: {
        weeklyTop: [],
        weeklyBottom: [],
      }, //首页每周特价列表
      weeklyType: 1, //切换每周特价中西药 1为西药 2为中药 默认为1
      drugsList: [], //好药推荐列表
      drugsListBanner: "", //好药推荐右侧大图
      indexPopup: false, //首页弹窗
      popupData: {},
      timer: null, //秒杀定时器
      countDownTime: "",
      popupImg: "",
      weekLyCountDownDay: "",
      weekLyCountDownHour: "",
      weekLyCountDownMin: "",
      weekLyCountDownSec: "",
      weekLyTimer: null,
      CollectPopup: false, //收藏弹出框
      NoCollectPopup: false, //取消收藏弹出框
      seckillStartTime: -1, //秒杀获取后台返回服务器时间
      scrabbleCountDownDay: "",//拼团倒计时-等参数
      scrabbleCountDownHour: "",
      scrabbleCountDownMin: "",
      scrabbleCountDownSec: "",
      scrabbleTimer: null,
      hour: "",
      minute: "",
      sec: "",
      statusTime: 0,
      end: "",
      day: "",
      endDay: "",
      endHour: "",
      endMinute: "",
      endSec: "",
      timestamp: 0,
      chooseIndex: 0,
      tabs: [{ title: '首页', id: 0 }, { title: '诊所精选', id: 7 }, { title: '聚划算', id: 2 }, { title: '套餐专区', id: 8 }, { title: '精选商品', id: 4 }, { title: '为你推荐', id: 5 }],
    };
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
    this.loadSeckillsInfo();
    this.steepDiscount();
    this.scrabbleDoughList();
    var that = this;
    var inner = document.getElementsByClassName("stairs");
    // 注册滚动监听事件
    window.onscroll = function () {
      // 获取滚动条距离页面底部的距离
      var tops = document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(tops)
      //判断滚动的位置，从而改变楼层选项的样式
      for (var i = 0; i < inner.length; i++) {
        if (inner[i].offsetTop <= tops + 600 && tops <= inner[i].offsetTop) {
          that.num = i;
        }
      }
    };
  },
  mounted() {
    this.$store.dispatch("getNavbarData");
    const father = this;
    this.setIntervalObj = setInterval(function () {
      father.REDUCE_SECKILLS_TIME();
    }, 1000);
    const weekTime = this;
    this.setIntervalWeekly = setInterval(function () {
      weekTime.REDUCE_WEEKLY_SPECIAL_TIME();
    }, 1000);
    /*左侧悬浮框效果*/
    $(function () {
      //1.内容大于800px scroll--->scrollTop
      $(window).on("scroll", function () {
        var $scroll = $(this).scrollTop();
        if ($scroll >= 240) {
          $("#floorBarId").show();
        } else {
          $("#floorBarId").hide();
        }
        if ($scroll >= 1000) {
          $(".backTop").show();
        } else {
          $(".backTop").hide();
        }

        //设置左侧导航栏高亮
        /*       $(".stairs").each(function () {
                 var $loutitop = $(".stairs").eq($(this).index()).offset().top + 400;

                 /!*   console.log($loutitop);*!/
                 if ($loutitop > $scroll) {
                   //设置高亮
                   $("#floorNavList li").removeClass("active");
                   $("#floorNavList li").eq($(this).index()).addClass("active");
                   return false;
                 }
               });*/
      });

      /*      var $loutili = $("#floorNavList li").not(".last");
            $loutili.on("click", function () {
              $(this).addClass("active").siblings("li").removeClass("active");
              var $loutitop = $(".stairs").eq($(this).index()).offset().top-460;

              $("html,body").animate({
                //$('html,body')
                scrollTop: $loutitop,
              });
            });*/
      //3.返回顶部
      $(".backTop").on("click", function () {
        $("html,body").animate({
          //$('html,body')
          scrollTop: 0,
        });
      });
    });
    /*左侧悬浮框效果*/

    /*右侧悬浮框效果*/
    $(".online-service").on({
      mouseover: function () {
        $(".call-num").show();
      },
      mouseout: function () {
        $(".call-num").hide();
      },
    });

    /*右侧悬浮框效果*/
    /* 超值钜惠轮播 */
    var overflowGoods = new Swiper(".overflow-content .swiper-container", {
      slidesPerView: 5, // 每页显示几个slide
      spaceBetween: 0, // slide的间距px
      followFinger: false, //
      speed: 1000, // 速度
      mousewheel: true, // 鼠标滚轮控制
      loop: $(".overflow-content .swiper-slide").length > 5, // 循环
      autoplay: false,
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true,
      scrollbar: {
        el: ".overflow-content .swiper-scrollbar",
        dragSize: 200,
      },
    });
    overflowGoods.scrollbar.$el.css("height", "3px");
    overflowGoods.scrollbar.$dragEl.css("background", "#358DD1");
    this.steepDiscount();

    /*好药推荐轮播*/
    var swiperGoods = new Swiper(".good-rec-content .swiper-container", {
      slidesPerView: 4, // 每页显示几个slide
      spaceBetween: 0, // slide的间距px
      followFinger: false, //
      speed: 1000, // 速度
      mousewheel: true, // 鼠标滚轮控制
      loop: $(".good-rec-content .swiper-slide").length > 2, // 循环

      autoplay: {
        delay: 5000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
      },
      scrollbar: {
        el: ".good-rec-content .swiper-scrollbar",
        dragSize: 30,
      },
    });
    swiperGoods.scrollbar.$el.css("height", "3px");
    swiperGoods.scrollbar.$dragEl.css("background", "#358DD1");
    this.seckillList();
    this.indexList();
    this.indexBrandList();
    this.weeklyList();
    this.indexImg();
    console.log("用户所有数据：", this.userAllData);
    setTimeout(() => {
      if (this.scrabbleList && this.scrabbleList.length > 0) {
        this.tabs.splice(1, 0, { title: '超值拼团', id: 1 })
      }

      if (this.steepList && this.steepList.length > 0) {
        this.tabs.splice(4, 0, { title: '超值钜惠', id: 3 })
      }
    }, 2000)
  },
  watch: {
    curSeckillIndex: {
      handler(newVal, oldVal) {
        let _this = this;
        if (this.curSeckillIndex > this.seckillGoodList.length - 1) {
          this.curSeckillIndex = this.seckillGoodList.length - 1;
        }
        this.curSeckillData = this.seckillGoodList[this.curSeckillIndex];
        clearInterval(_this.timer);
        // 切换时立即计算
        this.seckillStartTime = new Date(
          this.curSeckillData.now_time
        ).getTime();
        this.countDownTime = this.countDown(
          this.seckillStartTime, //这里改成now_time
          this.curSeckillData.end_time
        );
        _this.timer = setInterval(() => {
          _this.countDownTime = _this.countDown(
            this.seckillStartTime, //这里改成now_time
            this.curSeckillData.end_time
          );
        }, 1000);
      },
      deep: true,
    },
  },
  methods: {
    handleScroll() {
      const scrollY = window.scrollY;

      this.tabs.forEach((section) => {
        const sectionElement = document.querySelector('#nav' + section.id);
        const sectionTop = sectionElement.getBoundingClientRect().top + scrollY;

        if (scrollY >= sectionTop + -170) {
          this.chooseIndex = section.id;
        }
      });
    },
    anchorPoint(index) {
      document.querySelector('#nav' + index).scrollIntoView({
        behavior: "smooth"
      });
      this.chooseIndex = index;
      // 点击之后要做的事
    },
    // 楼层跳转的方法index
    // jump(index) {
    //   this.num = index;
    //   var body = document.getElementsByTagName("body")[0];
    //   // 获取所有的楼层
    //   var inner = document.getElementsByClassName("stairs");
    //   // console.log(body);
    //   // console.log(inner);
    //   // console.log(index);
    //   // console.log(inner[index].offsetTop);
    //   window.scrollTo(0, inner[index].offsetTop - 600);
    //   // document.body.scrollTop=inner[index].offsetTop
    //   // console.log(body.scrollTop);
    // },
    /* 超值拼团列表 */
    scrabbleDoughList() {
      let _this = this;
      getIndexScrabbleDough().then((res) => {
        _this.scrabbleList = res.data;
        console.log("拼团列表-----------", _this.scrabbleList);
        this.scrabbleList.map(item => {
          let time = item.type == 1 ? item.start_date : item.end_date;
          let diff = this.diff(time, item.now_time);
          item.timestamp = diff.seconds;
          return item
        })


        console.log("data----------", this.timestamp, this.scrabbleList);


      });
    },
    diff(eTime = "", sTime = "") {
      if (sTime) {
        sTime = new Date(sTime);
      } else {
        sTime = new Date();
      }
      eTime = new Date(eTime);
      var difftime = eTime - sTime; //计算时间差
      let seconds = parseInt(difftime / 1000);
      return {
        seconds,
      };
    },

    endTime() {
      console.log('end------');
      this.scrabbleDoughList()
    },
    // 加入购物车  都调用这个action
    ...mapActions(["goodAddScrabbleCart", "loadGoodsList"]),

    // 加入购物车按钮
    addToCart(item) {
      // limit  已达限购数量
      if (parseInt(item.add_init) > parseInt(item.limit)) {
        this.$message.error("已达限购数量，不可操作");
        return;
      }
      let _this = this;
      // 拼装加入购物车参数  调接口
      let good = {
        quantity: item.add_init,
        goods_id: item.goods_id,

      };
      // item.add_init = goods.quantity;
      // 统一在这里调接口
      this.goodAddScrabbleCart(good)
        .then(res => {
          _this.$Message.success(res.msg);
          // _this.$set(_this.goodsList, index, item);
        })
        .catch(err => {
          _this.$Message.error(err);
        });
    },
    /**加号点击 */
    addCart(item, index) {
      console.log("新增购物车", item, index);
      if (parseInt(item.add_init) > parseInt(item.limit)) {
        this.$message.error("已达限购数量，不可操作");
        item.quantity = item.quantity_max;
        this.$set(this.scrabbleList, index, item);
        return;
      }
      let quantity = parseInt(item.add_init);
      // 购买量，zbz_type为1时，购买量倍数增加；zbz_type为0时，在购买量基础上按照1增加
      if (item.zbz_type + "" === "1") {
        quantity = quantity + item.add_change;
      } else {
        quantity++;
      }
      if (parseInt(item.limit) > 0 && quantity > parseInt(item.limit)) {
        this.$message.error("购买量超过限购数量");
        return;
      }
      if (quantity > parseInt(item.goods_number)) {
        this.$message.error("购买量已到最大库存量");
        return;
      }
      /*  console.log(333,item.add_init,item.limit_pro);
        if(item.add_init === item.limit_pro){
          this.$message.warning("超过特价限购部分 按正常价计算");
        }*/

      const data = {
        quantity: quantity
      };
      item.add_init = quantity;
      // 手动更新数据
      this.$set(this.scrabbleList, index, item);
    },
    /**减号点击 */
    reduceCart(item, index) {
      if (parseInt(item.limit) === 0) {
        this.$message.error("已达限购数量，不可操作");
        item.quantity = item.quantity_min;
        this.$set(this.scrabbleList, index, item);
        return;
      }
      let quantity = Number(item.add_init);
      // 最低购买量
      let minLimit = 0;
      minLimit = item.quantity_min;
      // 购买量，zbz_type为1时，购买量倍数增加；zbz_type为0时，在购买量基础上按照1增加
      if (item.zbz_type + "" === "1") {
        quantity = quantity - item.add_change;
      } else {
        quantity--;
      }
      // 最低购买量
      if (quantity < parseInt(minLimit)) {
        this.$message.error("购买量不能低于最低购买量");
        item.quantity = minLimit;
        this.$set(this.scrabbleList, index, item);
        return;
      }
      const data = {
        quantity: quantity
      };
      item.add_init = quantity;
      this.$set(this.scrabbleList, index, item);
    },
    /** 手动修改数量 */
    quantityChange(item, index) {
      console.log("输入框数量", item.add_init);
      console.log("输入框余数", item.add_init % item.add_change);
      /*商品按照中包装购买时 判断手动输入数量是否为中包装 不是则商品数量向上取整*/
      if (parseInt(item.zbz_type) === 1) {
        if (item.add_init % item.add_change != 0) {
          this.$message.warning("温馨提示：您所选择的数量接近中包装，自动调整为中包装，并按中包装整数倍购买。");
          item.add_init = (item.add_init - (item.add_init % item.add_change)) + item.add_change;
        }
      }
      if (parseInt(item.limit) === 0) {
        this.$message.error("已达限购数量，不可操作");
        item.quantity = item.quantity_min;
        this.$set(this.scrabbleList, index, item);
        return;
      }
      let quantity = Number(item.add_init);
      // 最低购买量
      let minLimit = 0;
      minLimit = item.quantity_min;
      if (quantity < parseInt(minLimit)) {
        this.$message.error("购买量不能低于最低购买量");
        item.quantity = minLimit;
        this.$set(this.scrabbleList, index, item);

        return;
      }
      // 限购数
      if (parseInt(item.limit) > 0 && quantity > parseInt(item.limit)) {
        this.$message.error("购买量超过限购数量");
        item.quantity = item.quantity_max;
        this.$set(this.scrabbleList, index, item);

        return;
      }
      // 库存
      if (quantity > parseInt(item.goods_number)) {
        this.$message.error("购买量超过最大库存量");
        item.quantity = item.quantity_max;
        this.$set(this.scrabbleList, index, item);

        return;
      }
      //判断特价限购数据
      /*   if(item.limit_pro > 0 && item.add_init > item.limit_pro){
           this.$message.warning("超过特价限购部分 按正常价计算");
         }*/
      const data = {
        quantity: quantity
      };
      item.add_init = quantity;
      this.$set(this.scrabbleList, index, item);
    },
    /* 超值钜惠列表 */
    steepDiscount() {
      let _this = this;
      getIndexBargains().then((res) => {
        _this.steepList = res.data.bargains.lists;
        console.log("钜惠", _this.steepList);
      });
    },
    indexImg() {
      /**首页弹出框图片 */
      let _this = this;
      getIndexBulletFrame({ type: 1 })
        .then((res) => {
          console.log("获取首页弹框图", res);
          if (
            !isEmpty(res.data.BulletFrame) &&
            !isEmpty(res.data.BulletFrame.img_url)
          ) {
            _this.popupData = res.data.BulletFrame;
            // 未登录就一直弹出  已登录且关闭过一次就不弹了
            if (!this.userName || this.indexPopState + "" === "0")
              _this.indexPopup = true;
          } else {
            // this.indexPopup = false
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    weeklyList() {
      /**首页每周特价列表*/
      let _this = this;
      getWeeklyList({ type: this.weeklyType })
        .then((res) => {
          console.log("获取每周特价列表", res);
          this.weeklyIndexList = res.data.chosen;
          let weeklyIndexList = res.data.chosen;
          _this.weeklyIndexList.weeklyTop = weeklyIndexList.lists.slice(0, 2);
          _this.weeklyIndexList.weeklyBottom = weeklyIndexList.lists.slice(
            2,
            7
          );
          clearInterval(_this.weekLyTimer);
          let weekLyCountDownTime = _this.countDown(
            null,
            weeklyIndexList.end_time,
            1
          );
          _this.weekLyCountDownDay = weekLyCountDownTime.day;
          _this.weekLyCountDownHour = weekLyCountDownTime.hour;
          _this.weekLyCountDownMin = weekLyCountDownTime.minute;
          _this.weekLyCountDownSec = weekLyCountDownTime.second;
          _this.weekLyTimer = setInterval(() => {
            let weekLyCountDownTime = _this.countDown(
              null,
              weeklyIndexList.end_time,
              1
            );
            _this.weekLyCountDownDay = weekLyCountDownTime.day;

            _this.weekLyCountDownHour = weekLyCountDownTime.hour;
            _this.weekLyCountDownMin = weekLyCountDownTime.minute;
            _this.weekLyCountDownSec = weekLyCountDownTime.second;
          }, 1000);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    westernGoods() {
      /**每周特价切换为西药*/
      $(".weekly-classify-ul li").toggleClass("active");
      this.weeklyType = 1;
      this.weeklyList();
    },
    /* chineseGoods() {
         /!**每周特价切换为中药*!/
         $(".weekly-classify-ul li").toggleClass("active");
         this.weeklyType = 2;
         this.weeklyList();
       },*/
    indexList() {
      /**首页中间层列表*/
      let _this = this;
      getIndexCenter()
        .then((res) => {
          console.log("获取中间层列表", res);
          this.indexCenterList = res.data;
          this.newList = res.data.new.lists;
          this.newListBanner = res.data.new.banner;
          this.drugsList = res.data.hao.lists;
          this.drugsListBanner = res.data.hao.banner;
          // this.indexPopup = res.data.BulletFrame;
          this.hotGoodsList = res.data.hot;
          let hotGoodsList = res.data.hot;
          /*  console.log("获取热卖列表", hotGoodsList.banner);*/
          _this.hotGoodsList.banner = hotGoodsList.banner;
          _this.hotGoodsList.goodsL = hotGoodsList.lists.slice(0, 1);
          _this.hotGoodsList.goodsR = hotGoodsList.lists.slice(1, 2);
          _this.hotGoodsList.goodsBottom = hotGoodsList.lists.slice(2, 8);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    indexBrandList() {
      /**首页品牌专区列表*/
      let _this = this;
      getBrandList()
        .then((res) => {
          console.log("获取首页品牌列表", res);
          this.brandIndexList = res.data.lists;
          this.brandIndexBanner = res.data.banner;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLabels(labels) {
      return labels.split(",").length > 4
        ? labels.split(",").slice(3)
        : labels.split(",");
    },
    seckillList() {
      /**秒杀列表*/
      let _this = this;
      getIndexSeckill()
        .then((res) => {
          console.log("获取秒杀列表", res);
          this.seckillGoodList = res.data;
          if (this.seckillGoodList.length > 0) {
            // 排序
            this.seckillGoodList.sort(function (a, b) {
              return b.type - a.type;
            });
            this.curSeckillData = this.seckillGoodList[0];
            clearInterval(_this.timer);
            this.seckillStartTime = new Date(
              this.curSeckillData.now_time
            ).getTime();
            this.countDownTime = _this.countDown(
              this.seckillStartTime, //这里改成now_time
              this.curSeckillData.end_time
            );
            _this.timer = setInterval(() => {
              _this.countDownTime = _this.countDown(
                this.seckillStartTime, //这里改成now_time
                this.curSeckillData.end_time
              );
            }, 1000);
            this.$nextTick(() => {
              this.handleSeckillSwiper();
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSeckillSwiper() {
      if (this.seckillGoodList && this.seckillGoodList.length > 0) {
        /*秒杀轮播*/
        var swiper = new Swiper(".seckill-content .swiper-container", {
          slidesPerView: 4, // 每页显示几个slide
          spaceBetween: 0, // slide的间距px
          followFinger: false, //
          speed: 1000, // 速度
          mousewheel: true, // 鼠标滚轮控制
          loop: $(".seckill-content .swiper-slide").length > 2, // 循环
          autoplay: {
            delay: 5000,
            stopOnLastSlide: false,
            disableOnInteraction: true,
          },
          scrollbar: {
            el: ".seckill-content .swiper-scrollbar",
            dragSize: 30,
          },
        });
        swiper.scrollbar.$el.css("height", "3px");
        swiper.scrollbar.$dragEl.css("background", "#358DD1");
      }
    },
    time() {
      /*倒计时*/
      var that = this;
      var interval = setInterval(function timestampToTime() {
        var date = new Date(结束的时间戳) - new Date();
        //new Date当前的时间戳，也可以换成自定义的时间戳
        if (date > 0) {
          let time = date / 1000;
          // 获取时、分、秒,毫秒
          that.hou =
            parseInt((time % (60 * 60 * 24)) / 3600) < 10
              ? "0" + parseInt((time % (60 * 60 * 24)) / 3600)
              : parseInt((time % (60 * 60 * 24)) / 3600);
          that.min =
            parseInt(((time % (60 * 60 * 24)) % 3600) / 60) < 10
              ? "0" + parseInt(((time % (60 * 60 * 24)) % 3600) / 60)
              : parseInt(((time % (60 * 60 * 24)) % 3600) / 60);
          that.sec =
            parseInt(((time % (60 * 60 * 24)) % 3600) % 60) < 10
              ? "0" + parseInt(((time % (60 * 60 * 24)) % 3600) % 60)
              : parseInt(((time % (60 * 60 * 24)) % 3600) % 60);
          that.ssec = parseInt(((date % (60 * 60 * 24)) % 3600) / 60) % 10;
        } else {
          //活动已结束，全部设置为'00'
          // console.log("aaa")
          (that.day = "00"),
            (that.hou = "00"),
            (that.min = "00"),
            (that.sec = "00");
        }
      }, 100);
    },
    goIndexDetail(item) {
      // TODO 首页详情跳转
      console.log(222, item);
      // this.$router.push({
      //   path: item.ad_url
      //   /* query: { id: item.goods_id }*/
      // });
      // 跳转新页面
      window.open(this.$router.resolve({ path: item.ad_url }).href, "_blank");
    },
    goBrandList(item) {
      //  跳转品牌单独列表页面
      console.log(233, item);
      this.$router.push({
        path: "/BrandList",
        query: {
          brand_id: item.id,
        },
      });
    },
    /**秒杀倒计时 0-秒杀倒计时  1 每周特价倒计时*/
    countDown(startTime, endtime, type = 0) {
      // 是否需要计算秒杀开始时间？
      // const seconds = Math.round(
      //   (new Date(endtime).getTime() - new Date().getTime()) / 1000
      // );
      // 新修改为取服务器倒计时时间
      let seconds = 0;
      if (!startTime) {
        seconds = Math.round(
          (new Date(endtime).getTime() - new Date().getTime()) / 1000
        );
        if (seconds <= 0) {
          this.scrabbleDoughList();
        }
      } else {
        seconds = Math.round(
          (new Date(endtime).getTime() - this.seckillStartTime) / 1000
        );
      }
      if (seconds <= 0) {
        clearInterval(this.timer);
        return "秒杀已结束";
      }
      // console.log('时间差：', seconds);
      const second = seconds % 60;
      const minutes = (seconds - second) / 60;
      const minute = minutes % 60;
      const hours = (minutes - minute) / 60;
      const hour = hours % 24;
      const day = (hours - hour) / 24;
      const res =
        (day * 24 + hour < 10 ? "0" + (day * 24 + hour) : day * 24 + hour) +
        ": " +
        (minute < 10 ? "0" + minute : minute) +
        ": " +
        (second < 10 ? "0" + second : second);
      // console.log(day + '天 ' + hour + '小时 ' + minute + '分钟 ' + second + '秒 ')
      this.seckillStartTime += 500;
      if (type === 0) return res;
      else
        return {
          day: day,
          hour: hour < 10 ? "0" + hour : hour,
          minute: minute < 10 ? "0" + minute : minute,
          second: second < 10 ? "0" + second : second,
        };
    },
    ...mapActions([
      "signOut",
      "isLogin",
      "loadSeckillsInfo",
      "loadShoppingCart",
    ]),
    ...mapMutations(["REDUCE_SECKILLS_TIME", "REDUCE_WEEKLY_SPECIAL_TIME"]),
    openCart() {
      if (this.sideCart == false) {
        $(".floorRight").css({ right: "250px" });
        this.sideCart = true;
      } else {
        this.sideCart = false;
        $(".floorRight").css({ right: "1%" });
      }
    },
    close() {
      this.sideCart = false;
      $(".floorRight").css({ right: "1%" });
    },
    // 收藏	1添加2取消
    handleCollect(item, type, index, dataType) {
      console.log("首页收藏点击，", item, type, index, dataType);
      collection({
        goods_id: item.goods_id,
        type: type,
      })
        .then((res) => {
          if (res.code + "" !== "200") return;
          this.$store.dispatch("goods/setRightRefresh", Math.random() * 10);

          if (type == 1) {
            this.CollectPopup = true;
            switch (dataType) {
              case "weeklyIndexList.weeklyTop":
                item.favorites_type = 1;
                this.$set(this.weeklyIndexList.weeklyTop, index, item);

                break;
              case "weeklyIndexList.weeklyBottom":
                item.favorites_type = 1;
                this.$set(this.weeklyIndexList.weeklyBottom, index, item);

                break;
              case "hotGoodsList.goodsL":
                item.favorites_type = 1;
                this.$set(this.hotGoodsList.goodsL, index, item);

                break;
              case "hotGoodsList.goodsR":
                item.favorites_type = 1;
                this.$set(this.hotGoodsList.goodsR, index, item);

                break;
              case "hotGoodsList.goodsBottom":
                item.favorites_type = 1;
                this.$set(this.hotGoodsList.goodsBottom, index, item);

                break;

              default:
                break;
            }
          } else {
            this.NoCollectPopup = true;
            this.collectState = true;
            switch (dataType) {
              case "weeklyIndexList.weeklyTop":
                item.favorites_type = 0;
                this.$set(this.weeklyIndexList.weeklyTop, index, item);

                break;
              case "weeklyIndexList.weeklyBottom":
                item.favorites_type = 0;
                this.$set(this.weeklyIndexList.weeklyBottom, index, item);

                break;
              case "hotGoodsList.goodsL":
                item.favorites_type = 0;
                this.$set(this.hotGoodsList.goodsL, index, item);

                break;
              case "hotGoodsList.goodsR":
                item.favorites_type = 0;
                this.$set(this.hotGoodsList.goodsR, index, item);

                break;
              case "hotGoodsList.goodsBottom":
                item.favorites_type = 0;
                this.$set(this.hotGoodsList.goodsBottom, index, item);

                break;

              default:
                break;
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(err);
        });
    },
  },
  computed: {
    ...mapState(["userInfo", "seckills", "weekly", "computer", "eat"]),
    ...mapState({
      indexPopState: (state) => state.app.indexPopState,
    }),
    ...mapGetters([
      "seckillsHours",
      "seckillsMinutes",
      "seckillsSeconds",
      "weeklyHours",
      "weeklyMinutes",
      "weeklySeconds",
      "userName",
      "userAllData",
    ]),
  },
  components: {
    Search,
    HomeNav,
    RightFlex,
    BackTop,
    Recommend,
    IndexPopup,
    Collect,
    NoCollect,
    Countdown,
    SetMealArea
  },
  destroyed() {
    clearInterval(this.setIntervalObj);
    clearInterval(this.setIntervalWeekly);
    clearInterval(this.timer);
    clearInterval(this.weekLyTimer);
    /*销毁滚动监听*/
    window.removeEventListener("scroll", this.handleScroll);
  },
  store,
};
</script>

<style lang="less" scoped>
.public-container {}

.container {
  background-color: #fff;
}

.content {
  width: 1200px;
  margin: 0 auto;
}

/*标签*/
/*单促销标签*/
.pro-one {

  // display: none;
  .promotion-gm {
    width: 50px;
    height: 50px;
    background: linear-gradient(180deg, #ff4367 0%, #fe5789 100%);
    box-shadow: 0px 2px 6px 0px rgba(184, 18, 50, 0.2);
    font-size: 16px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #ffffff;
    line-height: 50px;
    text-align: center;
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: 10px;
    z-index: 10;
    // display: none;
  }

  .promotion-xp {}

  .promotion-zs {
    width: 62px;
    height: 62px;
    position: absolute;
    top: -4px;
    left: 10px;
    z-index: 10;
    // display: none;
  }

  .promotion-hg {
    width: 62px;
    height: 62px;
    position: absolute;
    top: -4px;
    left: 10px;
    z-index: 10;
    // display: none;
  }

  .promotion-ms {
    width: 62px;
    height: 62px;
    position: absolute;
    top: -4px;
    left: 10px;
    z-index: 10;
    // display: none;
  }

  .promotion-xq {
    width: 66px;
    height: 64px;
    position: absolute;
    top: -4px;
    left: 10px;
    z-index: 10;
    // display: none;
  }

  .promotion-tj {
    width: 64px;
    height: 63px;
    position: absolute;
    top: -4px;
    left: 10px;
    z-index: 10;
  }

  .promotion-txt {
    width: 140px;
    position: absolute;
    top: 8px;
    left: 70px;
    font-size: 12px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #999999;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

/*多促销标签*/
.pro-more {
  width: 100%;
  position: absolute;
  z-index: 4;

  .pro-other {
    display: inline-block;
    font-size: 12px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #999999;
    box-sizing: border-box;
    padding: 5px 8px;
    width: 156px;
    background: #fff;
    box-shadow: 0px 2px 4px 0px rgba(216, 216, 216, 0.3);
    border-radius: 6px;
    position: relative;
    text-align: left;
    line-height: 14px;
  }

  .pro-other-1 {
    display: none;
  }

  .pro-other-1::after {
    content: "";
    position: absolute;
    left: 22px;
    top: -5%;
    width: 0;
    height: 0px;
    border-style: solid;
    border-width: 7px;
    border-color: #fff #fff transparent transparent;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
    box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
  }

  .pro-other-2 {
    display: none;
  }

  .pro-other-2::after {
    content: "";
    position: absolute;
    left: 39px;
    top: -5%;
    width: 0;
    height: 0px;
    border-style: solid;
    border-width: 7px;
    border-color: #fff #fff transparent transparent;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
    box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
  }

  .pro-other-3 {
    margin-left: -37%;
    display: none;
  }

  .pro-other-3::after {
    content: "";
    position: absolute;
    left: 62px;
    top: -5%;
    width: 0;
    height: 0px;
    border-style: solid;
    border-width: 7px;
    border-color: #fff #fff transparent transparent;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
    box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
  }

  .pro-other-4 {
    margin-left: -98%;
    display: none;
  }

  .pro-other-4::after {
    content: "";
    position: absolute;
    left: 120px;
    top: -5%;
    width: 0;
    height: 0px;
    border-style: solid;
    border-width: 7px;
    border-color: #fff #fff transparent transparent;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
    box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
  }

  .pro-more-1 {
    width: 57px;
    height: 26px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    background: url("/static/img/goodsList/pro_more_1.png") no-repeat;
    font-size: 12px;
    font-family: PingFangHK-Semibold, PingFangHK;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
    line-height: 26px;
  }

  .pro-more-1:hover .pro-other-1 {
    display: block;
  }

  .pro-more-2 {
    width: 82px;
    height: 26px;
    position: absolute;
    top: 0;
    left: 38px;
    z-index: 9;
    background: url("/static/img/goodsList/pro_more_2.png") no-repeat;
    font-size: 12px;
    font-family: PingFangHK-Semibold, PingFangHK;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
    text-indent: 10px;
    line-height: 26px;
  }

  .pro-more-2:hover .pro-other-2 {
    display: block;
  }

  .pro-more-3 {
    width: 77px;
    height: 26px;
    position: absolute;
    top: 0;
    left: 99px;
    z-index: 8;
    background: url("/static/img/goodsList/pro_more_3.png") no-repeat;
    font-size: 12px;
    font-family: PingFangHK-Semibold, PingFangHK;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
    text-indent: 7px;
    line-height: 26px;
  }

  .pro-more-3:hover .pro-other-3 {
    display: block;
  }

  .pro-more-4 {
    width: 81px;
    height: 26px;
    position: absolute;
    top: 0;
    left: 148px;
    z-index: 7;
    background: url("/static/img/goodsList/pro_more_4.png") no-repeat;
    font-size: 12px;
    font-family: PingFangHK-Semibold, PingFangHK;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
    text-indent: 19px;
    line-height: 26px;
  }

  .pro-more-4:hover .pro-other-4 {
    display: block;
  }
}

/*标签*/
/*首页悬浮框*/
.floor {
  position: fixed;
  left: 7%;
  top: 12%;
  z-index: 10;
  width: 100px;
  /*height: 280px;*/
  background: #ffffff;
  box-shadow: 0px 4px 8px 0px rgba(196, 196, 196, 0.2);
  border-radius: 10px;
  border: 1px solid #f0f0f0;
  text-align: center;
  display: none;
  padding-bottom: 23px;

  .floor-left-ul li {
    font-size: 14px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
    padding-top: 23px;
    cursor: pointer;
  }

  .floor-left-ul li:hover {
    color: #358dd1;
  }

  .floor-left-ul .active {
    color: #358dd1;
  }

  .floor-nav {
    font-size: 14px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #999999;
    line-height: 40px;
    padding-top: 23px;
    cursor: pointer;
  }

  .sele {
    color: #358dd1;
  }
}

.coupons-img {
  position: fixed;
  left: 3.5%;
  top: 58%;
  z-index: 10;
}

.floorRight {
  z-index: 10;
  position: fixed;
  right: 1%;
  top: 25%;
  width: 80px;
  height: 400px;
  background: #ffffff;
  box-shadow: 0px 4px 8px 0px rgba(196, 196, 196, 0.2);
  border-radius: 10px;
  border: 1px solid #f0f0f0;

  .floorRight-ul {
    position: relative;

    li {
      margin-top: 16px;
      cursor: pointer;
      color: #999999;

      a {
        color: #999999;
      }
    }
  }

  .floorRight-ul li:hover .floorRight-txt {
    color: #358dd1;
  }

  .call-num {
    position: absolute;
    top: 10%;
    right: 100%;
    width: 150px;
    height: 134px;
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(216, 216, 216, 0.3);
    border-radius: 6px;
    border: 1px solid #f0f0f0;
    text-align: center;
    cursor: pointer;
    display: none;

    .call-icon {
      width: 0;
      height: 0;
      border-top: 10px solid transparent;
      border-left: 11px solid #fff;
      border-bottom: 10px solid transparent;
      position: absolute;
      top: 50px;
      right: -10px;
    }

    .call-img {
      width: 74px;
      height: 41px;
      margin: 14px auto auto auto;
    }

    .call-txt {
      font-size: 14px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
      padding-top: 10px;
      padding-bottom: 6px;
    }

    .call-line {
      width: 10px;
      /* height: 1px;*/
      border-top: 1px solid #e2e2e2;
      margin: 0 auto;
    }

    .call-phoneNum {
      font-size: 16px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 500;
      color: #358dd1;
      line-height: 22px;
      padding-top: 6px;
    }
  }

  .call-num::after {
    content: "";
    position: absolute;
    right: -6px;
    top: 50px;
    width: 0;
    height: 0px;
    border-style: solid;
    border-width: 7px;
    border-color: #fff #fff transparent transparent;
    transform: rotate(-316deg);
    box-shadow: 3px -3px 3px rgba(216, 216, 216, 0.3);
  }

  .img {
    width: 18px;
    height: 22px;
    margin: 0 auto;
  }

  .img1 {
    background: url(/static/img/index/indexIcon.png) no-repeat -126px -51px;
  }

  .floorRight-ul li:hover .img1 {
    background: url(/static/img/index/indexIcon.png) no-repeat -90px -51px;
  }

  .img2 {
    background: url(/static/img/index/indexIcon.png) no-repeat -200px -51px;
  }

  .floorRight-ul li:hover .img2 {
    background: url(/static/img/index/indexIcon.png) no-repeat -164px -51px;
  }

  .img3 {
    background: url(/static/img/index/indexIcon.png) no-repeat -271px -51px;
  }

  .floorRight-ul li:hover .img3 {
    background: url(/static/img/index/indexIcon.png) no-repeat -235px -51px;
  }

  .img4 {
    background: url(/static/img/index/indexIcon.png) no-repeat -343px -51px;
  }

  .floorRight-ul li:hover .img4 {
    background: url(/static/img/index/indexIcon.png) no-repeat -307px -51px;
  }

  .img5 {
    background: url(/static/img/index/indexIcon.png) no-repeat -55px -85px;
  }

  .floorRight-ul li:hover .img5 {
    background: url(/static/img/index/indexIcon.png) no-repeat -19px -85px;
  }

  .img6 {
    background: url(/static/img/index/indexIcon.png) no-repeat -128px -85px;
  }

  .floorRight-ul li:hover .img6 {
    background: url(/static/img/index/indexIcon.png) no-repeat -92px -85px;
  }

  .img7 {
    background: url(/static/img/index/indexIcon.png) no-repeat -200px -85px;
  }

  .floorRight-ul li:hover .img7 {
    background: url(/static/img/index/indexIcon.png) no-repeat -164px -85px;
  }

  .floorRight-txt {
    font-size: 12px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #999999;
    line-height: 17px;
    text-align: center;
  }
}

/*首页悬浮框*/

/*****************************秒杀专栏开始*****************************/
/*秒杀专栏*/
.seckill {
  width: 100%;
  height: 350px;
  margin: 40px auto 20px auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;

  .seckill-head {
    width: 230px;
    height: 350px;
    background: linear-gradient(180deg, #ff6161 0%, #ff4353 100%);
    border-radius: 6px;
  }

  .seckill-icon {
    width: 71px;
    margin: 24px auto auto auto;
  }

  .seckill-icon img {
    width: 71px;
    height: 76px;
    margin: 0 auto;
    animation-name: shake-clock;
    animation-duration: 0.3s;
    animation-iteration-count: infinite;
    /*设置无线循环*/
  }

  /*定义闹钟震动动画关键帧*/
  @keyframes shake-clock {
    0% {
      transform: rotate(-8deg);
    }

    50% {
      transform: rotate(8deg);
    }

    100% {
      transform: rotate(-8deg);
    }
  }

  .seckill-text {
    font-size: 24px;
    font-family: PingFangHK-Semibold, PingFangHK;
    font-weight: 600;
    color: #ffffff;
    line-height: 33px;
    text-align: center;
    padding-top: 10px;
  }

  /*倒计时*/
  .count-down {
    font-size: 0;
    font-family: PingFangHK-Semibold, PingFangHK;
    font-weight: 600;
    color: #ffffff;
    letter-spacing: 1px;
    text-align: center;
  }

  .count-down span {
    font-size: 36px;
  }

  .count-down-text {
    color: #fff;
  }

  .seckill-text-1 {
    font-size: 14px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #ffffff;
    line-height: 20px;
    text-align: center;
    padding-top: 10px;
  }

  .seckill-more {
    display: block;
    width: 150px;
    height: 36px;
    line-height: 36px;
    background: #ffc40f;
    box-shadow: 0px 2px 8px 0px rgba(200, 151, 0, 0.29);
    border-radius: 36px;
    text-align: center;
    color: #fff;
    margin: 26px auto auto auto;
  }

  .next-seckill {
    font-size: 14px;
    font-family: PingFangHK-Medium, PingFangHK;
    font-weight: 500;
    color: #ffffff;
    text-align: center;
    padding-top: 17px;
    cursor: pointer;
  }

  .seckill-content {
    width: 959px;
    height: 350px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #f0f0f0;
    box-shadow: 0px 4px 12px 0px rgba(179, 179, 179, 0.2);

    .swiper-container {
      width: 100%;
    }

    .swiper-slide {
      text-align: center;
    }

    .swiper-scrollbar {
      background: #f0f0f0;
    }

    .swiper-container-horizontal>.swiper-scrollbar {
      bottom: 15px;
    }
  }

  .swiper-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    /* flex-flow: row wrap;
     align-content: flex-start;*/
  }

  .seckill-item {
    /*flex: 0 0 25%;*/
    width: 225px;
    height: 350px;
    margin-left: 15px;
    cursor: pointer;

    .seckill-item-img {
      width: 165px;
      height: 140px;
      margin: 0 auto;
      overflow: hidden;
      background-size: 100% 100%;
      margin-top: 30px;
    }

    .seckill-item-img img {
      width: 165px;
      height: 140px;
      transition: margin-top 0.3s;
    }

    .seckill-item-img:hover img {
      margin-top: 6px;
      transition: margin-top 0.3s;
    }
  }

  .seckill-item-info {
    .seckill-item-intro {
      font-size: 16px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
      padding-top: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .seckill-item-spec {
      font-size: 12px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #999999;
      line-height: 17px;
      padding-top: 10px;
    }

    .seckill-item-noLogin {
      font-size: 14px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #fa0000;
      line-height: 20px;
      padding-top: 20px;
    }

    .seckill-item-loginPrice {
      padding-top: 10px;
    }

    .seckill-price {
      font-size: 14px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 500;
      color: #fa0000;
      line-height: 20px;
    }

    .seckill-old-price {
      font-size: 12px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #999999;
      line-height: 17px;
    }
  }

  .seckill-item-info /deep/ .ivu-progress-bg {
    background-color: #ff6161;
  }

  .seckill-item-info /deep/ .ivu-progress-inner {
    background-color: #ffe6e7;
  }

  .seckill-item-info /deep/ .ivu-progress {
    margin-top: 10px;
  }
}

.seckill /deep/ .swiper-slide {
  width: 225px;
  height: 350px;
}

/*****************************秒杀专栏结束*****************************/
/*****************************超值钜惠结束*****************************/
.overflowList {
  margin-top: 60px;

  .weekly-title {
    .hot-content {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      margin-top: 15px;
    }

    .weekly-title-logo {
      font-size: 40px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 500;
      color: #333333;
      line-height: 56px;
      width: 188px;
    }

    .weekly-time {
      width: 100%;
      border-bottom: 2px solid #040707;
      margin-left: 15px;
      color: #333333;
      height: 45px;

      .weekly-deadline {
        font-size: 24px;
        font-family: PingFangHK-Medium, PingFangHK;
        font-weight: 500;
        color: #333333;
        line-height: 33px;
        padding-bottom: 9px;
      }

      .weekly-more {
        text-align: right;
      }

      .weekly-more a {
        font-size: 14px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #999999;
        line-height: 33px;
      }

      .weekly-more a:hover {
        color: #358dd1;
      }
    }
  }

  .overflow-content {
    width: 1200px;
    height: 300px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #f0f0f0;
    box-shadow: 0px 4px 12px 0px rgba(179, 179, 179, 0.2);
    margin-top: 40px;

    .swiper-container {
      width: 100%;
    }

    .swiper-slide {
      text-align: center;
      width: 240px;
      height: 330px;
    }

    .swiper-scrollbar {
      background: #f0f0f0;
    }

    .swiper-container-horizontal>.swiper-scrollbar {
      bottom: 45px;
    }

    .seckill-item {
      /*flex: 0 0 25%;*/
      width: 225px;
      height: 350px;

      cursor: pointer;

      .seckill-item-img {
        width: 230px;
        height: 230px;
        margin: 0 auto;
        overflow: hidden;
        background-size: 100% 100%;
        margin-top: 30px;
      }

      .seckill-item-img img {
        width: 230px;
        height: 230px;
        transition: margin-top 0.3s;
      }

      .seckill-item-img:hover img {
        margin-top: 6px;
        transition: margin-top 0.3s;
      }
    }
  }

}

/*****************************超值钜惠结束*****************************/
/*****************************三个广告位*****************************/
.weekly-item-prefecture {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  /* margin-top: 15px;*/
  margin: 40px 0;

  .weekly-pre-img {
    width: 390px;
    height: 180px;
    margin-right: 15px;
    box-shadow: 0px 4px 8px 0px rgb(179 179 179 / 20%);

    img {
      width: 390px;
      height: 180px;
    }
  }

  .weekly-pre-img:last-child {
    margin-right: 0;
  }
}

/*****************************三个广告位*****************************/
/*****************************每周特价专栏开始*****************************/
.weeklySpecial {
  margin-top: 60px;

  .hot-content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }

  .weekly-title {
    .weekly-title-logo {
      font-size: 40px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 500;
      color: #333333;
      line-height: 56px;
      width: 188px;
    }

    .weekly-time {
      width: 100%;
      border-bottom: 2px solid #040707;
      margin-left: 15px;
      color: #333333;
      height: 45px;

      .weekly-deadline {
        font-size: 24px;
        font-family: PingFangHK-Medium, PingFangHK;
        font-weight: 500;
        color: #333333;
        line-height: 33px;
        padding-bottom: 9px;
      }

      .weekly-more {
        text-align: right;
      }

      .weekly-more a {
        font-size: 14px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #999999;
        line-height: 33px;
      }

      .weekly-more a:hover {
        color: #358dd1;
      }
    }
  }

  /*.weekly-title {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    .weekly-title-logo {
      width: 152px;
      height: 39px;
      img {
        width: 152px;
        height: 39px;
        margin-top: 9px;
      }
    }

    .weekly-time {
      width: 100%;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      border-bottom: 2px solid #040707;
      margin-left: 15px;
      color: #333333;
      padding-bottom: 9px;
      .weekly-deadline {
        font-size: 24px;
        font-family: PingFangHK-Medium, PingFangHK;
        font-weight: 500;
        color: #333333;
        line-height: 33px;
        padding-bottom: 9px;
      }
      !*倒计时*!
      .count-down {
      }
      .count-down-text {
        color: #fff;
      }
      .count-down-num {
        padding: 1px 10px;
        font-size: 24px;
        font-family: PingFangHK-Semibold, PingFangHK;
        font-weight: 600;
        color: #ffffff;
        line-height: 33px;
        letter-spacing: 1px;
        background-color: #333333;
        border-radius: 17px;
      }
      .count-down-point {
        font-size: 24px;
        font-family: PingFangHK-Semibold, PingFangHK;
        font-weight: 600;
        color: #333333;
        line-height: 33px;
        letter-spacing: 1px;
      }
      .weekly-more a {
        font-size: 14px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #999999;
        line-height: 33px;
      }
      .weekly-more a:hover {
        color: #358dd1;
      }
    }
  }*/
  .weekly-classify {
    .weekly-classify-ul {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: flex-end;
      font-size: 14px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #333333;
      padding: 28px 0;
    }

    .weekly-classify-ul li {
      padding-left: 20px;
      cursor: pointer;
    }

    .weekly-classify-ul li:hover {
      color: #358dd1;
    }

    .weekly-classify-ul li.active {
      color: #358dd1;
    }
  }

  .composition {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;

    .weekly-other-item {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-around;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      text-align: center;
    }
  }

  .week-items {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;

    /*  -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;*/
    .week-items-carousel {
      width: 715px;
      height: 280px;
      min-height: 280px;
      box-shadow: 0px 4px 12px 0px rgba(179, 179, 179, 0.2);
      margin-right: 12px;

      .demo-carousel {
        height: 280px;
        min-height: 280px;
      }
    }

    .week-items-carousel /deep/ .ivu-carousel-list {
      min-height: 280px;
      height: 280px;
      cursor: pointer;
    }

    .week-items-carousel {}

    .week-items-carousel /deep/ .ivu-carousel-dots-inside {
      bottom: 20px;
    }

    .week-items-carousel /deep/ .ivu-carousel-dots li button {
      background: #358dd1;
    }
  }

  .week-items-bottom {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-top: 15px;

    .weekly-goods:last-child {
      margin-right: 0;
    }
  }

  .weekly-other-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-around;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    text-align: center;

    .weekly-goods {
      width: 230px;
      height: 280px;
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #f0f0f0;
      box-shadow: 0px 4px 8px 0px rgba(179, 179, 179, 0.2);
      position: relative;
      margin-right: 12px;
    }

    .weekly-goods:last-child {
      margin-right: 0;
    }

    .weekly-goods-icon {
      width: 50px;
      height: 50px;
      background: linear-gradient(180deg, #ff4367 0%, #fe5789 100%);
      box-shadow: 0px 2px 6px 0px rgba(184, 18, 50, 0.2);
      font-size: 16px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #ffffff;
      line-height: 50px;
      text-align: center;
      border-radius: 50%;
      position: absolute;
      top: 0;
      left: 10px;
      z-index: 2;
    }

    .weekly-goods-icon-1 {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 30px;
      height: 30px;
      color: #fff;
      background: #358dd1;
      cursor: pointer;
      border-radius: 50%;
      text-align: center;
      line-height: 30px;
      box-shadow: 0px 2px 4px 0px rgba(0, 124, 176, 0.29);
      display: none;
      z-index: 2;

      span {
        line-height: 33px;
      }
    }

    .weekly-goods:hover .weekly-goods-icon-1 {
      display: block;
    }

    .weekly-goods-icon-2 {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 30px;
      height: 30px;
      background: #fd4a68;
      box-shadow: 0px 2px 4px 0px rgba(253, 74, 104, 0.3);
      color: #fff;
      cursor: pointer;
      border-radius: 50%;
      text-align: center;
      line-height: 30px;
      display: none;
      z-index: 10;

      span {
        line-height: 33px;
      }
    }

    .weekly-goods:hover .weekly-goods-icon-2 {
      display: block;
    }

    .weekly-goods-img {
      width: 190px;
      height: 140px;
      margin: 43px auto auto auto;

      img {
        width: 190px;
        height: 140px;
      }

      .move-img:hover {
        /* transform: translateY(-5px);
        transition-duration: 1s;*/
      }
    }

    .weekly-goods-intro {
      font-size: 16px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #333333;
      padding: 0 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .weekly-goods-spec {
      font-size: 12px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #999999;
      padding-top: 8px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .weekly-goods-noLogin {
      font-size: 14px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #fa0000;
      padding-top: 8px;
    }

    .weekly-goods-loginPrice {
      padding-top: 8px;

      .weekly-price {
        font-size: 14px;
        font-family: PingFangHK-Medium, PingFangHK;
        font-weight: 500;
        color: #fa0000;
        line-height: 20px;
      }

      .weekly-old-price {
        font-size: 12px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #999999;
        line-height: 17px;
      }
    }
  }

  .weekly-item-prefecture {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-top: 15px;

    .weekly-pre-img {
      width: 390px;
      height: 180px;
      margin-right: 15px;
      box-shadow: 0px 4px 8px 0px rgb(179 179 179 / 20%);

      img {
        width: 390px;
        height: 180px;
      }
    }

    .weekly-pre-img:last-child {
      margin-right: 0;
    }
  }
}

/*****************************每周特价专栏结束*****************************/

/*****************************热销商品专栏开始*****************************/
.hotGoods-item {
  margin-top: 30px;

  .hot-content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }

  .weekly-title {
    .weekly-title-logo {
      font-size: 40px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 500;
      color: #333333;
      line-height: 56px;
      width: 188px;
    }

    .weekly-time {
      width: 100%;
      border-bottom: 2px solid #040707;
      margin-left: 15px;
      color: #333333;
      height: 45px;

      .weekly-deadline {
        font-size: 24px;
        font-family: PingFangHK-Medium, PingFangHK;
        font-weight: 500;
        color: #333333;
        line-height: 33px;
        padding-bottom: 9px;
      }

      .weekly-more {
        text-align: right;
      }

      .weekly-more a {
        font-size: 14px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #999999;
        line-height: 33px;
      }

      .weekly-more a:hover {
        color: #358dd1;
      }
    }
  }

  .weekly-classify {
    .weekly-classify-ul {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: flex-end;
      font-size: 14px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #333333;
      padding: 28px 0;
    }

    .weekly-classify-ul li {
      padding-left: 20px;
      cursor: pointer;
    }

    .weekly-classify-ul li:hover {
      color: #358dd1;
    }

    .weekly-classify-ul li.active {
      color: #358dd1;
    }
  }

  .week-items {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-top: 20px;

    /*  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;*/
    .week-items-carousel {
      width: 715px;
      height: 280px;
      box-shadow: 0px 4px 12px 0px rgba(179, 179, 179, 0.2);
      margin-right: 12px;
    }

    .week-items-carousel {}

    .week-items-carousel /deep/ .ivu-carousel {
      height: 280px;
      min-height: 280px;
    }

    .week-items-carousel /deep/ .ivu-carousel-dots-inside {
      bottom: 20px;
    }

    .week-items-carousel /deep/ .ivu-carousel-dots li button {
      background: #358dd1;
    }
  }

  .week-items-bottom {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;

    .weekly-goods {
      margin-top: 15px;
    }

    .weekly-goods:nth-child(5n+5) {
      margin-right: 0;
    }
  }

  .weekly-other-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    /* justify-content: space-around;*/
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    text-align: center;

    .weekly-goods {
      width: 230px;
      height: 280px;
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #f0f0f0;
      box-shadow: 0px 4px 8px 0px rgba(179, 179, 179, 0.2);
      position: relative;
      margin-right: 12px;
    }

    .weekly-goods-icon {
      width: 50px;
      height: 50px;
      background: linear-gradient(180deg, #ff4367 0%, #fe5789 100%);
      box-shadow: 0px 2px 6px 0px rgba(184, 18, 50, 0.2);
      font-size: 16px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #ffffff;
      line-height: 50px;
      text-align: center;
      border-radius: 50%;
      position: absolute;
      top: 0;
      left: 10px;
      z-index: 10;
    }

    .weekly-goods-icon-1 {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 30px;
      height: 30px;
      color: #fff;
      background: #358dd1;
      cursor: pointer;
      border-radius: 50%;
      text-align: center;
      line-height: 30px;
      box-shadow: 0px 2px 4px 0px rgba(0, 124, 176, 0.29);
      display: none;
      z-index: 10;

      span {
        line-height: 33px;
      }
    }

    .weekly-goods:hover .weekly-goods-icon-1 {
      display: block;
    }

    .weekly-goods-icon-2 {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 30px;
      height: 30px;
      background: #fd4a68;
      box-shadow: 0px 2px 4px 0px rgba(253, 74, 104, 0.3);
      color: #fff;
      cursor: pointer;
      border-radius: 50%;
      text-align: center;
      line-height: 30px;
      display: none;
      z-index: 10;

      span {
        line-height: 33px;
      }
    }

    .weekly-goods:hover .weekly-goods-icon-2 {
      display: block;
    }

    .weekly-goods-img {
      width: 190px;
      height: 140px;
      margin: 43px auto auto auto;

      .move-img:hover {
        /* transform: translateY(-5px);
        transition-duration: 1s;*/
      }

      img {
        width: 190px;
        height: 140px;
        background-size: 100% 100%;
      }
    }

    .weekly-goods-intro {
      font-size: 16px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #333333;
      padding: 0 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .weekly-goods-spec {
      font-size: 12px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #999999;
      padding-top: 8px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .weekly-goods-noLogin {
      font-size: 14px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #fa0000;
      padding-top: 8px;
    }

    .weekly-goods-loginPrice {
      padding-top: 8px;

      .weekly-price {
        font-size: 14px;
        font-family: PingFangHK-Medium, PingFangHK;
        font-weight: 500;
        color: #fa0000;
        line-height: 20px;
      }

      .weekly-old-price {
        font-size: 12px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #999999;
        line-height: 17px;
      }
    }
  }
}

/*****************************热销商品专栏结束*****************************/

/*****************************新品推荐+品牌专区专栏开始******************/
.specialZone-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-top: 20px;

  .brandGoods-more {
    padding-right: 12px;
  }

  .brandGoods-more a {
    font-size: 14px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #999999;
    line-height: 45px;
  }

  .brandGoods-more a:hover {
    color: #358dd1;
  }

  .left-newPro {
    width: 590px;
    height: 368px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #f0f0f0;
    box-shadow: 0px 4px 8px 0px rgb(179 179 179 / 20%);
    margin-right: 20px;
    box-sizing: border-box;
    padding: 13px 0 20px 20px;

    .newGoods-title {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      box-sizing: border-box;
      /*  padding-right: 20px;*/
    }

    .newGoods-txt {
      font-size: 30px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 500;
      color: #333333;
    }

    .newGoods-txt-icon {}

    .newGoods-classify {
      font-size: 14px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #666666;
      line-height: 45px;
    }

    .newGoods-classify span {
      padding-left: 20px;
      cursor: pointer;
    }

    .newGoods-classify span:hover {
      color: #358dd1;
    }

    .newGoods-classify span.active {
      color: #358dd1;
    }

    .newGoods-item {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      margin-top: 13px;
    }

    .new-item-left {
      width: 200px;
      height: 280px;
      background: #f8f9fa;
      text-align: center;
      cursor: pointer;

      .new-left-img {
        width: 140px;
        height: 134px;
        margin: 30px auto auto auto;

        img {
          width: 140px;
          height: 134px;
        }
      }

      .move-img:hover {
        transform: translateY(-5px);
        transition-duration: 1s;
      }

      .new-left-intro {
        font-size: 16px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #333333;
        padding: 25px 20px 0 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .new-left-spec {
        font-size: 12px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #999999;
        padding-top: 5px;
      }

      .new-left-noLogin {
        font-size: 14px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #fa0000;
        padding-top: 8px;
      }

      .new-left-loginPrice {
        padding-top: 8px;
      }

      .new-left-price {
        font-size: 14px;
        font-family: PingFangHK-Medium, PingFangHK;
        font-weight: 500;
        color: #fa0000;
        line-height: 20px;
      }

      .new-left-oldPrice {
        font-size: 12px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #999999;
        line-height: 17px;
      }
    }
  }

  .new-item-right {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin: 0 10px;

    .new-right-content {
      width: 350px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      /* justify-content: space-around;*/
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;

      .new-right-flex {
        width: 175px;
        height: 80px;

        .new-right-box-1 {
          width: 175px;
          height: 80px;
          /* margin-top: 20px;*/
          display: flex;
          flex-direction: row;
          justify-content: space-around;
          cursor: pointer;
        }
      }

      .new-right-flex:first-child .new-right-box-1 {
        margin-top: 0;
      }

      .new-right-flex:nth-child(2) .new-right-box-1 {
        margin-top: 0;
      }

      .new-right-img {
        width: 80px;
        height: 80px;

        img {
          width: 80px;
          height: 80px;
        }

        .move-img:hover {
          /* transform: translateY(-5px);
          transition-duration: 1s;*/
        }
      }

      .new-right-describe {
        .new-right-intro {
          width: 76px;
          height: 34px;
          font-size: 12px;
          font-family: PingFangHK-Regular, PingFangHK;
          font-weight: 400;
          color: #333333;
          line-height: 17px;
          margin-top: 3px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }

        .new-right-spec {
          width: 76px;
          font-size: 12px;
          font-family: PingFangHK-Regular, PingFangHK;
          font-weight: 400;
          color: #a2a2a2;
          line-height: 17px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .new-right-noLogin {
          font-size: 12px;
          font-family: PingFangHK-Regular, PingFangHK;
          font-weight: 400;
          color: #fa0000;
          line-height: 17px;
          padding-top: 5px;
        }

        .new-right-loginPrice {
          padding-top: 5px;

          .new-right-price {
            font-size: 14px;
            font-family: PingFangHK-Medium, PingFangHK;
            font-weight: 500;
            color: #fa0000;
            line-height: 20px;
          }

          .new-right-oldPrice {
            font-size: 12px;
            font-family: PingFangHK-Regular, PingFangHK;
            font-weight: 400;
            color: #999999;
            line-height: 17px;
          }
        }
      }
    }
  }

  .right-brand {
    width: 590px;
    height: 368px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #f0f0f0;
    box-shadow: 0px 4px 8px 0px rgb(179 179 179 / 20%);
    box-sizing: border-box;
    padding: 13px 0 20px 20px;

    .brandGoods-title {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;

      .brandGoods-txt {
        font-size: 30px;
        font-family: PingFangHK-Medium, PingFangHK;
        font-weight: 500;
        color: #333333;
        line-height: 42px;
      }
    }

    .bandGoods-container {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      margin-top: 13px;

      .bandGoods-left-img {
        width: 200px;
        height: 280px;
        background: #f8f9fa;
        cursor: pointer;

        img {
          width: 200px;
          height: 280px;
        }
      }

      .bandGoods-right-goods {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
      }

      .bandGoods-right-ul {
        width: 370px;
        height: 280px;
        overflow: hidden;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        flex-flow: row wrap;
        align-content: flex-start;
        box-sizing: border-box;
        padding: 0 12px;

        .bandGoods-right-li {
          position: relative;
          padding-bottom: 8px;
          box-sizing: border-box;
          border-bottom: 1px solid #f0f0f0;
          cursor: pointer;

          .line {
            width: 115px;
            height: 53px;
            position: absolute;
            top: 15px;
            left: 0;
            box-sizing: border-box;
            border-right: 1px solid #f0f0f0;
          }

          a {
            display: block;
            width: 115px;
            height: 80px;
          }

          img {
            width: 115px;
            height: 80px;
          }
        }

        .bandGoods-right-li:nth-child(3n) .line {
          border-right: none;
        }
      }
    }
  }
}

/*****************************新品推荐+品牌专区专栏结束******************/

/*****************************好药推荐专栏开始******************/
.good-recommendation {
  width: 100%;
  height: 300px;
  margin: 40px auto 20px auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;

  .good-head {
    width: 230px;
    height: 300px;
    background: #f8f9fa;
    cursor: pointer;

    a {
      display: block;
      width: 230px;
      height: 300px;
    }

    img {
      width: 230px;
      height: 300px;
    }
  }

  .good-rec-content {
    width: 959px;
    height: 300px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #f0f0f0;
    box-shadow: 0px 4px 12px 0px rgba(179, 179, 179, 0.2);

    .swiper-container {
      width: 100%;
    }

    .swiper-slide {
      text-align: center;
      width: 240px;
      height: 330px;
    }

    .swiper-scrollbar {
      background: #f0f0f0;
    }

    .swiper-container-horizontal>.swiper-scrollbar {
      bottom: 45px;
    }
  }

  .swiper-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    /* flex-flow: row wrap;
     align-content: flex-start;*/
  }

  .seckill-item {
    /*flex: 0 0 25%;*/
    width: 225px;
    height: 330px;
    margin-left: 15px;
    cursor: pointer;

    .seckill-item-img {
      width: 165px;
      height: 140px;
      margin: 0 auto;
      overflow: hidden;
      background-size: 100% 100%;
      margin-top: 30px;
    }

    .seckill-item-img img {
      width: 165px;
      height: 140px;
      transition: margin-top 0.3s;
    }

    .seckill-item-img:hover img {
      margin-top: 6px;
      transition: margin-top 0.3s;
    }
  }

  .seckill-item-info {
    .seckill-item-intro {
      font-size: 16px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #333333;
      padding: 20px 20px 0 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .seckill-item-spec {
      font-size: 12px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #999999;
      line-height: 17px;
      padding-top: 5px;
    }

    .seckill-item-noLogin {
      font-size: 14px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #fa0000;
      line-height: 20px;
      padding-top: 20px;
    }

    .seckill-item-loginPrice {
      padding-top: 5px;
    }

    .seckill-price {
      font-size: 14px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 500;
      color: #fa0000;
      line-height: 20px;
    }

    .seckill-old-price {
      font-size: 12px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #999999;
      line-height: 17px;
    }
  }

  .seckill-item-info /deep/ .ivu-progress-bg {
    background-color: #ff6161;
  }

  .seckill-item-info /deep/ .ivu-progress-inner {
    background-color: #ffe6e7;
  }
}

.good-item-prefecture {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-top: 15px;

  .weekly-pre-img {
    width: 590px;
    height: 240px;
    margin-right: 20px;
    box-shadow: 0px 4px 8px 0px rgb(179 179 179 / 20%);

    img {
      width: 590px;
      height: 240px;
    }
  }

  .weekly-pre-img:last-child {
    margin-right: 0;
  }
}

/*****************************好药推荐专栏结束******************/

/*****************************超值拼团专栏开始******************/
.scrabbleDough {
  .weekly-title {
    .hot-content {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      margin-top: 50px;
    }

    .weekly-title-logo {
      font-size: 40px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 500;
      color: #333333;
      line-height: 56px;
      width: 188px;
    }

    .weekly-time {
      width: 100%;
      border-bottom: 2px solid #040707;
      margin-left: 15px;
      color: #333333;
      height: 45px;

      .weekly-deadline {
        font-size: 24px;
        font-family: PingFangHK-Medium, PingFangHK;
        font-weight: 500;
        color: #333333;
        line-height: 33px;
        padding-bottom: 9px;
      }

      .weekly-more {
        text-align: right;
      }

      .weekly-more a {
        font-size: 14px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #999999;
        line-height: 33px;
      }

      .weekly-more a:hover {
        color: #358dd1;
      }
    }
  }

  .scrabbleDough-content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
    -ms-flex-line-pack: start;
    align-content: flex-start;

    .scrabbleDough-box {
      width: 285px;
      height: 536px;
      background: #FFFFFF;
      box-shadow: 0px 2px 6px 0px rgba(220, 220, 220, 0.3);
      border-radius: 6px;
      border: 1px solid #F0F0F0;
      margin-right: 20px;
      margin-top: 20px;

      .scrabbleDough-img {
        width: 245px;
        height: 183px;
        margin: 20px auto auto auto;

        img {
          width: 245px;
          height: 183px;
        }
      }

      .scrabbleDough-time {
        width: 100%;
        height: 80px;
        background: linear-gradient(137deg, #FF5756 0%, #FF2625 100%);
        box-shadow: 0px 2px 6px 0px rgba(220, 220, 220, 0.3);
        border-radius: 10px 10px 0px 0px;
        opacity: 0.89;
        color: #fff;
        box-sizing: border-box;
        padding: 5px 20px;

        .scrabbleDough-people {
          display: flex;
          justify-content: space-between;
          font-size: 12px;

          .num-size {
            font-size: 16px;
          }

          .line24 {
            line-height: 24px;
          }
        }

        .scrabbleDough-timeBox {
          display: flex;
          justify-content: space-between;
          font-size: 12px;
          margin-top: 3px;

          .num-size {
            font-size: 16px;
          }

          .scrabbleDough-countdown /deep/ .u-countdown-item {
            width: 18px !important;
            height: 18px !important;
            line-height: 18px !important;
            background: rgba(255, 255, 255, 0.9) !important;
            box-shadow: 0px 2px 6px 0px rgba(220, 220, 220, 0.3) !important;
            font-size: 12px !important;
            border-radius: 4px !important;
          }

          .scrabbleDough-countdown /deep/ .u-countdown-time {
            font-size: 12px !important;
            color: #FF2020 !important;
            line-height: 18px !important;
            font-weight: 400 !important;
          }

          .scrabbleDough-countdown /deep/ .u-countdown-colon {
            font-size: 12px !important;
          }

          .time-box {
            display: inline-block;
            width: 18px;
            height: 18px;
            line-height: 18px;
            background: rgba(255, 255, 255, 0.9);
            box-shadow: 0px 2px 6px 0px rgba(220, 220, 220, 0.3);
            border-radius: 4px;
            text-align: center;
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FF2020;
          }
        }

        .scrabbleDough-progress {}

        .scrabbleDough-progress /deep/ .ivu-progress-inner {
          background: rgba(255, 220, 220, 0.3);
          box-shadow: 0px 2px 6px 0px rgba(220, 220, 220, 0.3);
        }

        .scrabbleDough-progress /deep/ .ivu-progress-bg {
          background: #FFFFFF;
          box-shadow: 0px 2px 6px 0px rgba(220, 220, 220, 0.3);
        }
      }

      .scrabbleDough-m20 {
        box-sizing: border-box;
        padding: 0 20px;

        .scrabbleDough-name {
          font-size: 16px;
          font-family: PingFangHK-Medium, PingFangHK;
          font-weight: 500;
          color: #333333;
          text-shadow: 0px 2px 6px rgba(220, 220, 220, 0.3);
          padding-top: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .scrabbleDough-manu {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          text-shadow: 0px 2px 6px rgba(220, 220, 220, 0.3);
          padding-top: 9px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .scrabbleDough-spec {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          text-shadow: 0px 2px 6px rgba(220, 220, 220, 0.3);
          padding-top: 6px;
        }

        .scrabbleDough-expiryDate {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          text-shadow: 0px 2px 6px rgba(220, 220, 220, 0.3);
          padding-top: 6px;
        }

        .scrabbleDough-rule {
          padding: 6px 0 6px 10px;
          background: #FFF1F1;
          box-shadow: 0px 2px 6px 0px rgba(220, 220, 220, 0.3);
          border-radius: 4px;
          font-size: 12px;
          font-family: PingFangHK-Medium, PingFangHK;
          font-weight: 500;
          color: #FF4341;
          text-shadow: 0px 2px 6px rgba(220, 220, 220, 0.3);
          margin-top: 9px;
        }

        .scrabbleDough-num {
          display: flex;
          justify-content: space-between;
          margin-top: 15px;

          .scrabbleDough-stock {
            font-size: 12px;
            font-family: PingFangHK-Regular, PingFangHK;
            font-weight: 400;
            color: #999999;
            text-shadow: 0px 2px 6px rgba(220, 220, 220, 0.3);

            .color {
              color: #FA0000;
            }
          }

          .goods-num {
            line-height: 24px;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            position: relative;

            span {
              cursor: pointer;
            }

            /* span {
              display: inline-block;
              width: 24px;
              height: 24px;
              background: #f8f8f8;
              text-align: center;
              border-radius: 50%;
              color: #d6000f;
            }*/
            .reduce-num {
              display: inline-block;
              width: 24px;
              height: 24px;
              background: #F8F8F8;
              text-align: center;
              border-radius: 50%;
              color: #DCDCDC;
            }

            .add-num {
              display: inline-block;
              width: 24px;
              height: 24px;
              background: #FF2020;
              text-align: center;
              border-radius: 50%;
              color: #FFF;
            }

            input {
              text-align: center;
              width: 33px;
              border: none;
              height: 24px;
              background: none;
              outline: none;
              border: 0;
              border-bottom: 1px solid #fff;
              border-bottom-left-radius: 1px;
              border-bottom-right-radius: 1px;
              box-sizing: border-box;
            }

            input:focus {
              border-bottom: 1px solid #f8f8f8;
            }

            input:active {
              border-bottom: 1px solid #f8f8f8;
            }
          }
        }

        .scrabbleDough-price {
          width: 100%;
          height: 36px;
          line-height: 36px;
          box-shadow: 0px 2px 6px 0px rgba(220, 220, 220, 0.3);
          border-radius: 4px;
          border: 1px solid #CCCCCC;
          display: flex;
          justify-content: space-between;
          margin-top: 10px;

          .goods-price {
            font-size: 14px;
            font-family: PingFangHK-Medium, PingFangHK;
            font-weight: 500;
            color: #fa0000;
            padding-left: 10px;
          }

          .goods-old-price {
            font-size: 12px;
            font-family: PingFangHK-Regular, PingFangHK;
            font-weight: 400;
            color: #999999;
            padding-left: 10px;
          }

          .goods-cart {
            width: 110px;
            height: 34px;
            line-height: 34px;
            border-radius: 0px 4px 4px 0px;
            font-size: 14px;
            font-family: PingFangHK-Medium, PingFangHK;
            font-weight: 500;
            background: #CCCCCC;
            box-shadow: 0px 2px 6px 0px rgba(220, 220, 220, 0.3);
            color: #FFFFFF;
            text-align: center;
          }

          .goods-cart-1 {
            width: 110px;
            height: 34px;
            line-height: 34px;
            background: #FF4C4B;
            box-shadow: 0px 2px 6px 0px rgba(220, 220, 220, 0.3);
            border-radius: 0px 4px 4px 0px;
            font-size: 14px;
            font-family: PingFangHK-Medium, PingFangHK;
            font-weight: 500;
            color: #FFFFFF;
            text-shadow: 0px 2px 6px rgba(220, 220, 220, 0.3);
            text-align: center;
            cursor: pointer;
          }
        }
      }
    }

    .scrabbleDough-box:nth-child(4n) {
      margin-right: 0;
    }

  }
}

/*****************************超值拼团专栏结束******************/

/*****************************为你推荐专栏开始******************/
.recommend {
  padding-bottom: 30px;

  .hot-content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    margin-top: 15px;
  }

  .weekly-title {
    .weekly-title-logo {
      font-size: 40px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 500;
      color: #333333;
      line-height: 56px;
      width: 188px;
    }

    .weekly-time {
      width: 100%;
      border-bottom: 2px solid #040707;
      margin-left: 15px;
      color: #333333;
      height: 45px;

      .weekly-deadline {
        font-size: 24px;
        font-family: PingFangHK-Medium, PingFangHK;
        font-weight: 500;
        color: #333333;
        line-height: 33px;
        padding-bottom: 9px;
      }

      .weekly-more {
        text-align: right;
      }

      .weekly-more a {
        font-size: 14px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #999999;
        line-height: 33px;
      }

      .weekly-more a:hover {
        color: #358dd1;
      }
    }
  }

  .weekly-classify {
    .weekly-classify-ul {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: flex-end;
      font-size: 14px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #333333;
      padding: 28px 0;
    }

    .weekly-classify-ul li {
      padding-left: 20px;
      cursor: pointer;
    }

    .weekly-classify-ul li:hover {
      color: #358dd1;
    }

    .weekly-classify-ul li.active {
      color: #358dd1;
    }
  }

  .week-items {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;

    /*  -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;*/
    .week-items-carousel {
      width: 715px;
      height: 280px;
      box-shadow: 0px 4px 12px 0px rgba(179, 179, 179, 0.2);
      margin-right: 12px;
    }

    .week-items-carousel {}

    .week-items-carousel /deep/ .ivu-carousel-dots-inside {
      bottom: 20px;
    }

    .week-items-carousel /deep/ .ivu-carousel-dots li button {
      background: #358dd1;
    }
  }

  .week-items-bottom {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-top: 30px;

    .weekly-goods:last-child {
      margin-right: 0;
    }
  }

  .weekly-other-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-flow: row wrap;
    align-content: flex-start;
    text-align: center;

    .weekly-goods {
      width: 230px;
      height: 280px;
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #f0f0f0;
      box-shadow: 0px 4px 8px 0px rgba(179, 179, 179, 0.2);
      position: relative;
      margin-right: 12px;
      margin-bottom: 15px;
    }

    .weekly-goods:nth-child(5) {
      margin-right: 0;
    }

    .weekly-goods-icon {
      width: 50px;
      height: 50px;
      background: linear-gradient(180deg, #ff4367 0%, #fe5789 100%);
      box-shadow: 0px 2px 6px 0px rgba(184, 18, 50, 0.2);
      font-size: 16px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #ffffff;
      line-height: 50px;
      text-align: center;
      border-radius: 50%;
      position: absolute;
      top: 0;
      left: 10px;
      z-index: 10;
    }

    .weekly-goods-icon-1 {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 30px;
      height: 30px;
      color: #fff;
      background: #358dd1;
      cursor: pointer;
      border-radius: 50%;
      text-align: center;
      line-height: 30px;
      box-shadow: 0px 2px 4px 0px rgba(0, 124, 176, 0.29);
      display: none;
      z-index: 10;

      span {
        line-height: 33px;
      }
    }

    .weekly-goods:hover .weekly-goods-icon-1 {
      display: block;
    }

    .weekly-goods {
      &:hover .weekly-goods-icon-2 {
        display: block;
      }
    }

    //
    .weekly-goods-icon-2 {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 30px;
      height: 30px;
      background: #fd4a68;
      box-shadow: 0px 2px 4px 0px rgba(253, 74, 104, 0.3);
      color: #fff;
      cursor: pointer;
      border-radius: 50%;
      text-align: center;
      line-height: 30px;
      display: none;

      z-index: 10;

      span {
        line-height: 33px;
      }
    }

    .weekly-goods:hover .weekly-goods-icon-2 {
      display: block;
    }

    .weekly-goods-img {
      width: 190px;
      height: 140px;
      margin: 43px auto auto auto;

      img {
        width: 190px;
        height: 140px;
      }

      .move-img:hover {
        /* transform: translateY(-5px);
        transition-duration: 1s;*/
      }
    }

    .weekly-goods-intro {
      font-size: 16px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #333333;
      padding: 0 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .weekly-goods-spec {
      font-size: 12px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #999999;
      padding-top: 8px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .weekly-goods-noLogin {
      font-size: 14px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #fa0000;
      padding-top: 8px;
    }

    .weekly-goods-loginPrice {
      padding-top: 8px;

      .weekly-price {
        font-size: 14px;
        font-family: PingFangHK-Medium, PingFangHK;
        font-weight: 500;
        color: #fa0000;
        line-height: 20px;
      }

      .weekly-old-price {
        font-size: 12px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #999999;
        line-height: 17px;
      }
    }
  }
}

/*****************************为你推荐专栏结束******************/

/*****************************商品专栏开始*****************************/
.item-class {
  width: 100%;
  height: 470px;
  margin-top: 15px;
  background-color: #fff;
}

.item-class-head {
  width: 100%;
  height: 50px;
  background-color: #4488a7;
}

.item-class-eat-head {
  background-color: #ecb226;
}

.item-class-head ul {
  list-style: none;
  float: right;
  margin-right: 30px;
  line-height: 50px;
}

.item-class-head a {
  padding: 6px;
  margin-left: 15px;
  font-size: 12px;
  background-color: #6da6be;
  border: 1px solid #6da6be;
  text-decoration: none;
  color: #fff;
}

.item-class-eat-head a {
  background-color: #eeb955;
  border: 1px solid #eeb955;
}

.item-class-head a:hover {
  border: 1px solid #fff;
}

.item-class-head li {
  float: left;
}

.item-class-title {
  font-size: 25px;
  line-height: 50px;
  color: #fff;
  margin-left: 15px;
}

.item-class-content {
  width: 49%;
  cursor: pointer;
  border-right: 1px solid #ccc;
  margin-left: 0.9%;
  /*background-color: #cff;*/
  float: left;
}

.item-class-content:nth-child(odd) {
  border: none;
}

.item-content-top {
  width: 100%;
  height: 260px;
}

.item-big-img {
  width: 180px;
  height: 260px;
  overflow: hidden;
  float: left;
}

.item-big-img img {
  margin-left: 0px;
  transition: margin-left 0.3s;
}

.item-big-img:hover img {
  margin-left: -15px;
  transition: margin-left 0.3s;
}

.item-four-img {
  width: 303px;
  margin-left: 8px;
  float: left;
}

.item-four-detail img {
  margin-left: 0px;
  transition: margin-left 0.3s;
}

.item-four-detail:hover img {
  margin-left: -6px;
  transition: margin-left 0.3s;
}

.item-four-detail {
  width: 152px;
  height: 130px;
  margin-left: -1px;
  float: left;
}

.item-four-detail:first-child {
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}

.item-four-detail:last-child {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}

.item-four-detail-text {
  width: 50px;
  margin-left: 5px;
  margin-top: 15px;
  float: left;
}

.item-four-detail-img {
  width: 96px;
  margin-top: 15px;
  overflow: hidden;
  float: left;
}

.item-four-detail-img img {
  margin-left: 5px;
  width: 90px;
}

.pt_bi_tit {
  font-weight: bold;
  font-size: 12px;
  color: #4488a7;
}

.pt_bi_tit-eat {
  color: #ecb127;
}

.pt_bi_promo {
  color: #00695c;
}

.item-content-bottom {
  width: 100%;
  margin-top: 8px;
}

.item-content-bottom-img {
  width: 156px;
  margin-right: 8px;
  overflow: hidden;
  float: left;
}

.item-content-bottom-img img {
  margin-left: 0px;
  transition: margin-left 0.3s;
}

.item-content-bottom-img:hover img {
  margin-left: -15px;
  transition: margin-left 0.3s;
}

.placeholderArea {
  position: absolute;
  top: -170px;
}

/*****************************商品专栏结束*****************************/
</style>



// WEBPACK FOOTER //
// src/components/Index.vue